// ATL Frontend
;(function(w, d){
	var itiInstance = null; // intlTelInput chính (customized tour / #atl-phone-input)
	var itiHolidayPopupInstance = null; // intlTelInput trong popup holiday
	var lastDetectedCountryCode = null; // ISO2 từ IP, dùng đồng bộ sau khi popup init

	function initIntlTel(selector, setPrimary) {
		setPrimary = setPrimary !== false;
		if (!w.intlTelInput) return null;
		var el = typeof selector === 'string' ? d.querySelector(selector) : selector;
		if (!el) return null;
		var instance = w.intlTelInput(el, {
			allowDropdown: true,
			autoInsertDialCode: true,
			autoPlaceholder: 'polite',
			formatOnDisplay: true,
			nationalMode: false,
			preferredCountries: ['us', 'gb'],
			separateDialCode: true,
			showFlags: true
		});
		if (setPrimary) {
			itiInstance = instance;
		}
		return instance;
	}

	function initPhone(selector, setPrimary) {
		setPrimary = setPrimary !== false;
		var input = d.querySelector(selector);
		if (!input || !w.intlTelInput) {
			if (!w.intlTelInput) setTimeout(function() { initPhone(selector, setPrimary); }, 100);
			return;
		}
		
		// Chỉ cho phép nhập số
		input.addEventListener('input', function(e) {
			e.target.value = e.target.value.replace(/[^0-9]/g, '');
		});
		
		// Ngăn paste non-numeric
		input.addEventListener('paste', function(e) {
			e.preventDefault();
			var paste = (e.clipboardData || w.clipboardData).getData('text');
			var numbers = paste.replace(/[^0-9]/g, '');
			if (numbers) {
				input.value = input.value + numbers;
			}
		});
		
		var telInstance = initIntlTel(input, setPrimary);
		if (telInstance && input.id === 'atl-holiday-popup-phone-input') {
			itiHolidayPopupInstance = telInstance;
		}
		return telInstance;
	}

	/**
	 * Số điện thoại E.164 cho tracking (gtag USER_PHONE).
	 * getNumber() cần intlTelInputUtils; nếu thiếu utils thì ghép +dialCode + số national.
	 */
	function getPhoneE164ForTracking(phoneInput) {
		if (!phoneInput) {
			return '';
		}
		var national = String(phoneInput.value || '').replace(/\D/g, '');
		var iti = null;

		if (w.intlTelInputGlobals && w.intlTelInputGlobals.getInstance) {
			iti = w.intlTelInputGlobals.getInstance(phoneInput);
		}
		if (!iti && phoneInput.id === 'atl-holiday-popup-phone-input' && itiHolidayPopupInstance) {
			iti = itiHolidayPopupInstance;
		}
		if (!iti && phoneInput.id === 'atl-phone-input' && itiInstance) {
			iti = itiInstance;
		}
		if (!iti) {
			return national;
		}

		if (typeof iti.getNumber === 'function') {
			var e164 = iti.getNumber();
			if (e164) {
				return e164;
			}
		}

		if (typeof iti.getSelectedCountryData === 'function') {
			var country = iti.getSelectedCountryData();
			if (country && country.dialCode && national) {
				return '+' + country.dialCode + national;
			}
		}

		return national;
	}

	w.atlGetPhoneE164ForTracking = getPhoneE164ForTracking;

	/**
	 * Random sales consultant qua AJAX — bypass LiteSpeed full-page cache.
	 * Một request / lần load trang; cùng avatar + tên cho mọi vị trí trên page đó.
	 */
	function getDefaultSalesConsultant() {
		var cfg = w.atlConfigAjax || {};
		return {
			avatar: cfg.default_sales_avatar || '',
			name: cfg.default_sales_name || 'Mr. Alan'
		};
	}

	function pageHasSalesConsultantTargets() {
		return !!(
			d.querySelector('.atl-success-avatar img') ||
			d.querySelector('.atl_consultant_avatar img')
		);
	}

	function applySalesConsultantData(data) {
		if (!data || !data.avatar) {
			return;
		}

		var name = data.name || getDefaultSalesConsultant().name;

		d.querySelectorAll('.atl-success-avatar img').forEach(function(img) {
			img.src = data.avatar;
			img.alt = name;
		});

		d.querySelectorAll('.atl_consultant_avatar img').forEach(function(img) {
			img.src = data.avatar;
			img.alt = name;
		});

		d.querySelectorAll('.atl_consultant_name').forEach(function(el) {
			el.textContent = name;
		});

		var holidayCard = d.getElementById('atl-holiday-popup-success');
		if (holidayCard && holidayCard.querySelector('.atl-success-avatar img')) {
			holidayCard.classList.remove('atl-holiday-popup__success--no-avatar');
			holidayCard.classList.add('atl-holiday-popup__success--with-avatar');
		}
	}

	function initRandomSalesConsultantAvatars() {
		var cfg = w.atlConfigAjax;
		if (!cfg || !cfg.ajax_url || !cfg.atl_random_sales_consultant_action) {
			return;
		}
		if (!pageHasSalesConsultantTargets()) {
			return;
		}

		var formData = new FormData();
		formData.append('action', cfg.atl_random_sales_consultant_action);

		fetch(cfg.ajax_url, {
			method: 'POST',
			body: formData,
			credentials: 'same-origin',
			cache: 'no-store'
		})
			.then(function(res) {
				if (!res.ok) {
					throw new Error('HTTP ' + res.status);
				}
				return res.json();
			})
			.then(function(json) {
				if (json && json.success && json.data) {
					applySalesConsultantData(json.data);
				}
			})
			.catch(function() {
				// Giữ avatar SSR từ HTML cache nếu AJAX lỗi.
			});
	}

	function getMinHolidayTravelDate() {
		var minDate = new Date();
		minDate.setHours(0, 0, 0, 0);
		minDate.setDate(minDate.getDate() + 3);
		return minDate;
	}

	/**
	 * Pikaday cho ô Travel date trong popup holiday: gắn calendar vào body, z-index cao;
	 * icon lịch không chặn click (CSS pointer-events: none + không ép pointerEvents:auto).
	 */
	function initHolidayPopupTravelDate() {
		var input = d.getElementById('atl-holiday-popup-travel-date');
		if (!input || input.getAttribute('data-atl-pikaday') === '1') return;
		if (!w.Pikaday) {
			w.setTimeout(initHolidayPopupTravelDate, 100);
			return;
		}
		var wrapper = input.closest('.atl_date_input_wrapper');
		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
		var picker = new w.Pikaday({
			field: input,
			trigger: wrapper || input,
			format: 'DD MMM, YYYY',
			minDate: getMinHolidayTravelDate(),
			yearRange: [new Date().getFullYear(), new Date().getFullYear() + 3],
			showDaysInNextAndPreviousMonths: true,
			enableSelectionDaysInNextAndPreviousMonths: true,
			i18n: {
				previousMonth: 'Previous Month',
				nextMonth: 'Next Month',
				months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
				weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
				weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
			},
			onOpen: function() {
				if (this.el) {
					this.el.style.zIndex = '10070';
				}
			},
			onSelect: function(date) {
				if (date && input) {
					input.value = date.getDate() + ' ' + months[date.getMonth()] + ', ' + date.getFullYear();
				}
			}
		});
		input.setAttribute('data-atl-pikaday', '1');
		input._atlPikaday = picker;
	}

	function initDatepicker(selector) {
		var input = d.querySelector(selector);
		if (!input) return;
		if (!w.Pikaday) {
			setTimeout(function(){ initDatepicker(selector); }, 100);
			return;
		}

		var wrapper = input.closest('.atl_date_input_wrapper');
		var icon = wrapper ? wrapper.querySelector('.atl_date_icon') : null;
		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
		
		var picker = new w.Pikaday({
			field: input,
			format: 'DD MMM, YYYY',
			minDate: getMinHolidayTravelDate(),
			yearRange: [new Date().getFullYear(), new Date().getFullYear() + 3],
			showDaysInNextAndPreviousMonths: true,
			enableSelectionDaysInNextAndPreviousMonths: true,
			i18n: {
				previousMonth: 'Previous Month',
				nextMonth: 'Next Month',
				months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
				weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
				weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
			},
			onSelect: function(date) {
				if (date && input) {
					input.value = date.getDate() + ' ' + months[date.getMonth()] + ', ' + date.getFullYear();
				}
			}
		});

		if (icon) {
			icon.style.pointerEvents = 'auto';
			icon.addEventListener('click', function(e) {
				e.preventDefault();
				if (picker && picker.show) picker.show();
			});
		}
	}

	// Country Detection functionality
	var countryDetection = {
		init: function() {
			this.initIPCaching();
		},
		
		initIPCaching: function() {
			// Check if AJAX variables are available
			if (!w.atlConfigAjax || !w.atlConfigAjax.ip_user) {
				console.log('Country detection AJAX or IP user not available');
				return;
			}
			
			var currentIP = w.atlConfigAjax.ip_user;
			var cachedIP = localStorage.getItem('atl_key_ip_user');
			var cachedCountryInfo = localStorage.getItem('atl_info_ip');
			
			// So sánh IP hiện tại với IP cached
			if (currentIP !== cachedIP) {
				localStorage.removeItem('atl_info_ip');
				localStorage.setItem('atl_key_ip_user', currentIP);
				this.detectCountryByIP();
			} else if (cachedCountryInfo) {
				try {
					var countryData = JSON.parse(cachedCountryInfo);
					this.setCountryData(countryData);
				} catch (parseError) {
					console.error('Error parsing cached country data:', parseError);
					localStorage.removeItem('atl_info_ip');
					this.detectCountryByIP();
				}
			} else {
				this.detectCountryByIP();
			}
		},
		
		detectCountryByIP: function() {
			// Check if AJAX variables are available
			if (!w.atlConfigAjax) {
				console.log('Country detection AJAX not available');
				return;
			}
			
			// Create FormData for the request
			var formData = new FormData();
			formData.append('action', 'get_country_by_ip');
			
			fetch(w.atlConfigAjax.ajax_url, {
				method: 'POST',
				body: formData
			})
			.then(function(response) {
				return response.text();
			})
			.then(function(text) {
				try {
					var response = JSON.parse(text);
					if (response.success && response.data) {
						var countryData = response.data;
						if (countryData.countryCode) {
							countryDetection.cacheCountryData(countryData);
							countryDetection.setCountryData(countryData);
						}
					} else if (response.data && response.data.countryCode) {
						countryDetection.cacheCountryData(response.data);
						countryDetection.setCountryData(response.data);
					}
				} catch (parseError) {
					console.error('Country detection parse error:', parseError);
				}
			})
			.catch(function(error) {
				console.error('Country detection error:', error);
			});
		},
		
		cacheCountryData: function(countryData) {
			try {
				// Save country data to localStorage
				localStorage.setItem('atl_info_ip', JSON.stringify(countryData));
			} catch (error) {
				console.error('Error caching country data:', error);
			}
		},
		
		setCountryData: function(countryData) {
			var countryCode = countryData.countryCode;
			if (countryCode) {
				lastDetectedCountryCode = String(countryCode).toLowerCase();
				this.setPhoneCountry(countryCode);
				this.setNationality(countryCode);
			}
		},

		/** Gọi sau khi init điện thoại popup + Pikaday. */
		syncHolidayPopupFromDetectedCountry: function() {
			if (!lastDetectedCountryCode) return;
			if (itiHolidayPopupInstance) {
				itiHolidayPopupInstance.setCountry(lastDetectedCountryCode);
			}
			this.setNationality(lastDetectedCountryCode);
		},

		
		setPhoneCountry: function(countryCode) {
			if (!countryCode) return;
			var code = countryCode.toLowerCase();
			if (itiInstance) {
				itiInstance.setCountry(code);
			}
			if (itiHolidayPopupInstance) {
				itiHolidayPopupInstance.setCountry(code);
			}
		},
		
		setNationality: function(countryCode) {
			if (!countryCode) {
				return;
			}
			var codeUpper = String(countryCode).toUpperCase();

			function setIfOptionExists(sel) {
				if (!sel || !sel.options) return;
				var ok = false;
				for (var o = 0; o < sel.options.length; o++) {
					if (sel.options[o].value === codeUpper) {
						ok = true;
						break;
					}
				}
				if (ok) {
					sel.value = codeUpper;
					sel.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}

			var nationalityById = d.getElementById('atl-nationality');
			if (nationalityById) {
				setIfOptionExists(nationalityById);
			}
			var allNationality = d.querySelectorAll('select[name="nationality"]');
			for (var i = 0; i < allNationality.length; i++) {
				setIfOptionExists(allNationality[i]);
			}
		}
	};

	// Mobile Menu functionality
	function initMobileMenu() {
		if (typeof jQuery === 'undefined') {
			setTimeout(initMobileMenu, 100);
			return;
		}

		var $ = jQuery;

		// Mobile menu toggle
		function toggleMobileMenu() {
			$('.atl-mobile-menu').toggleClass('active');
			$('.atl-mobile-menu-overlay').toggleClass('active');
			$('body').toggleClass('atl-mobile-menu-open');
		}

		function closeMobileMenu() {
			$('.atl-mobile-menu').removeClass('active');
			$('.atl-mobile-menu-overlay').removeClass('active');
			$('body').removeClass('atl-mobile-menu-open');
		}

		// Toggle menu on hamburger click
		$(document).on('click', '.atl-mobile-menu-toggle', function(e) {
			e.stopPropagation();
			toggleMobileMenu();
		});

		// Close menu when clicking on overlay
		$(document).on('click', '.atl-mobile-menu-overlay', function(e) {
			e.stopPropagation();
			closeMobileMenu();
		});

		// Close menu when clicking outside (on document/body)
		$(document).on('click', function(e) {
			if ($(window).width() <= 991) {
				var $target = $(e.target);
				// If click is outside menu and overlay, close menu
				if ($('.atl-mobile-menu').hasClass('active') && 
					!$target.closest('.atl-mobile-menu').length && 
					!$target.closest('.atl-mobile-menu-toggle').length &&
					!$target.closest('.atl-mobile-menu-overlay').length) {
					closeMobileMenu();
				}
			}
		});

		// Prevent menu from closing when clicking inside menu
		$(document).on('click', '.atl-mobile-menu', function(e) {
			e.stopPropagation();
		});

		// Handle submenu toggle on mobile
		$(document).on('click', '.atl-mobile-menu .nav > li.has-child > a', function(e) {
			if ($(window).width() <= 991) {
				e.preventDefault();
				e.stopPropagation();
				var $parent = $(this).parent('li');
				$parent.toggleClass('active');
				$parent.siblings('li').removeClass('active');
			}
		});

		// Close mobile menu when clicking on a link (non-submenu)
		$(document).on('click', '.atl-mobile-menu .nav > li:not(.has-child) > a', function() {
			if ($(window).width() <= 991) {
				closeMobileMenu();
			}
		});

		// Close menu on window resize if switching to desktop
		$(window).on('resize', function() {
			if ($(window).width() > 991) {
				closeMobileMenu();
			}
		});
	}

	// Home gallery slider (mobile) - Owl Carousel
	function initHomeGallerySlider() {
		if (typeof jQuery === 'undefined') {
			setTimeout(initHomeGallerySlider, 100);
			return;
		}

		var $ = jQuery;
		var $galleries = $('.iaj_gallery_owl');

		if (!$galleries.length) return;

		function destroyOwl($el) {
			if (!$el.hasClass('owl-loaded')) return;
			$el.trigger('destroy.owl.carousel');
			$el.removeClass('owl-carousel owl-loaded');
			$el.find('.owl-stage-outer').children().unwrap();
			$el.find('.owl-stage').children().unwrap();
			$el.find('.owl-nav, .owl-dots').remove();
		}

		function initOwl($el) {
			if ($el.hasClass('owl-loaded')) return;
			$el.addClass('owl-carousel');
			$el.owlCarousel({
				loop: true,
				margin: 10,
				center: false,
				nav: false,
				dots: true,
				autoWidth: false,
				autoplay: true,
				slideTransition: 'linear',
				autoplayTimeout: 4000,
				autoplaySpeed: 600,
				responsiveClass: true,
				responsive: {
					0: { items: 1 },
					480: { items: 2 },
					768: { items: 3 }
				}
			});
		}

		function toggleByViewport($el) {
			var isMobile = w.innerWidth <= 991;
			if (isMobile) {
				initOwl($el);
			} else {
				destroyOwl($el);
			}
		}

		$galleries.each(function () {
			var $el = $(this);
			toggleByViewport($el);
			$(w).on('resize.atlGallery', function () {
				toggleByViewport($el);
			});
		});
	}

	// Home gallery slider — main image + thumbnail navigation (gallery-slider.tpl.php)
	function initAtlGallerySlider() {
		var sliders = d.querySelectorAll('[data-atl-gallery-slider]');
		if (!sliders.length) return;

		sliders.forEach(function(sliderEl) {
			if (sliderEl.getAttribute('data-atl-gallery-slider-init') === '1') return;

			var stage = sliderEl.querySelector('.atl-gallery-slider__stage');
			var mainImg = sliderEl.querySelector('.atl-gallery-slider__main');
			var thumbs = sliderEl.querySelectorAll('.atl-gallery-slider__thumb');
			var lightboxLinks = sliderEl.querySelectorAll('.atl-gallery-slider__lightbox-src .elem');

			if (!stage || !mainImg) return;

			var activeIndex = 0;
			var autoplayTimer = null;
			var autoplayDelay = 5000;
			var slideCount = thumbs.length || lightboxLinks.length || 1;

			function openLightbox() {
				var link = lightboxLinks[activeIndex] || lightboxLinks[0];
				if (link) {
					link.click();
				}
			}

			function applyMainImage(src, srcset, title) {
				mainImg.alt = title;
				if (srcset) {
					mainImg.srcset = srcset;
				} else {
					mainImg.removeAttribute('srcset');
				}
				mainImg.src = src;
			}

			function setActive(index, force) {
				if (index < 0 || index >= slideCount) return;
				if (!force && index === activeIndex) return;

				var src = '';
				var srcset = '';
				var title = '';

				if (thumbs.length) {
					var thumb = thumbs[index];
					src = thumb.getAttribute('data-src') || '';
					srcset = thumb.getAttribute('data-srcset') || '';
					title = thumb.getAttribute('data-title') || '';
				} else if (lightboxLinks[index]) {
					src = lightboxLinks[index].getAttribute('href') || '';
					title = lightboxLinks[index].getAttribute('title') || '';
				}

				if (!src) return;

				activeIndex = index;

				if (thumbs.length) {
					thumbs.forEach(function(btn, i) {
						var isActive = i === index;
						btn.classList.toggle('is-active', isActive);
						btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
					});
				}

				if (mainImg.src === src && (!srcset || mainImg.srcset === srcset)) {
					return;
				}

				var loader = new Image();
				loader.onload = function() {
					applyMainImage(src, srcset, title);
				};
				loader.onerror = function() {
					applyMainImage(src, srcset, title);
				};
				if (srcset) {
					loader.srcset = srcset;
				}
				loader.src = src;
			}

			function startAutoplay() {
				if (slideCount < 2) return;
				stopAutoplay();
				autoplayTimer = w.setInterval(function() {
					setActive((activeIndex + 1) % slideCount, true);
				}, autoplayDelay);
			}

			function stopAutoplay() {
				if (autoplayTimer) {
					w.clearInterval(autoplayTimer);
					autoplayTimer = null;
				}
			}

			thumbs.forEach(function(thumb, index) {
				thumb.addEventListener('click', function() {
					setActive(index, true);
				});
			});

			stage.addEventListener('click', openLightbox);
			stage.addEventListener('keydown', function(e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					openLightbox();
				}
			});

			sliderEl.addEventListener('mouseenter', stopAutoplay);
			sliderEl.addEventListener('mouseleave', startAutoplay);
			sliderEl.addEventListener('focusin', stopAutoplay);
			sliderEl.addEventListener('focusout', function(e) {
				if (!sliderEl.contains(e.relatedTarget)) {
					startAutoplay();
				}
			});

			sliderEl.setAttribute('data-atl-gallery-slider-init', '1');
			startAutoplay();
		});
	}

	// Why choose us slider - keep first card fixed, slide remaining cards
	function initWhyChooseUsSlider() {
		if (!w.Swiper) {
			setTimeout(initWhyChooseUsSlider, 100);
			return;
		}

		var sliders = d.querySelectorAll('.atl-why-choose-us-slider');
		if (!sliders.length) return;

		sliders.forEach(function(sliderEl) {
			if (sliderEl.swiper) {
				sliderEl.swiper.destroy(true, true);
			}

			var totalSlides = sliderEl.querySelectorAll('.swiper-slide').length;
			var shouldLoop = totalSlides > 2;
			var nextBtn = sliderEl.querySelector('.swiper-button-next');
			var paginationEl = sliderEl.querySelector('.swiper-pagination');

			new w.Swiper(sliderEl, {
				slidesPerView: 1,
				spaceBetween: 12,
				loop: shouldLoop,
				watchOverflow: false,
				speed: 600,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false
				},
				navigation: {
					nextEl: nextBtn
				},
				pagination: {
					el: paginationEl,
					clickable: true
				},
				breakpoints: {
					768: {
						slidesPerView: 1,
						spaceBetween: 16
					},
					992: {
						slidesPerView: 2,
						spaceBetween: 30
					}
				}
			});
		});
	}

	// Toggle between Login and Register forms
	function initLoginRegisterToggle() {
		if (typeof jQuery === 'undefined') {
			setTimeout(initLoginRegisterToggle, 100);
			return;
		}

		var $ = jQuery;

		// Wait a bit to ensure DOM is ready, especially for sidebar content
		setTimeout(function() {
			// Use event delegation - works even if elements are dynamically added
			// Toggle to Register form
			$(document).on('click', '.atl-toggle-register', function(e) {
				e.preventDefault();
				e.stopPropagation();
				
				var $loginForm = $('#atl-login-form');
				var $registerForm = $('#atl-register-form');
				
				console.log('Register toggle clicked');
				console.log('Login form found:', $loginForm.length);
				console.log('Register form found:', $registerForm.length);
				
				if ($loginForm.length && $registerForm.length) {
					$loginForm.hide();
					$registerForm.show();
					console.log('Forms toggled successfully');
				} else {
					console.error('Login or Register form not found');
					console.log('Login form:', $loginForm);
					console.log('Register form:', $registerForm);
				}
			});

			// Toggle to Login form
			$(document).on('click', '.atl-toggle-login', function(e) {
				e.preventDefault();
				e.stopPropagation();
				
				var $loginForm = $('#atl-login-form');
				var $registerForm = $('#atl-register-form');
				
				console.log('Login toggle clicked');
				
				if ($loginForm.length && $registerForm.length) {
					$registerForm.hide();
					$loginForm.show();
					console.log('Forms toggled successfully');
				} else {
					console.error('Login or Register form not found');
				}
			});
			
			console.log('Login/Register toggle handlers initialized');
		}, 500);
	}

	// Festival Calendar Tabs Scroll & Transition
	function initFestivalTabsScroll() {
		var containers = d.querySelectorAll('.atl-festival-tabs-section .atl-tabs-nav-container');
		
		containers.forEach(function(container) {
			var wrapper = container.querySelector('.atl-tabs-nav-wrapper');
			var leftBtn = container.querySelector('.atl-tabs-scroll-left');
			var rightBtn = container.querySelector('.atl-tabs-scroll-right');
			
			if (!wrapper || !leftBtn || !rightBtn) return;
			
			// Get all tab buttons
			var tabButtons = wrapper.querySelectorAll('.nav-link');
			
			// Check if scroll buttons are needed
			function updateScrollButtons() {
				var hasScroll = wrapper.scrollWidth > wrapper.clientWidth;
				var isAtStart = wrapper.scrollLeft <= 0;
				var isAtEnd = wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth - 1;
				
				if (!hasScroll) {
					leftBtn.classList.add('hidden');
					rightBtn.classList.add('hidden');
				} else {
					leftBtn.classList.toggle('hidden', isAtStart);
					rightBtn.classList.toggle('hidden', isAtEnd);
				}
			}
			
			// Get current active tab index
			function getActiveTabIndex() {
				for (var i = 0; i < tabButtons.length; i++) {
					if (tabButtons[i].classList.contains('active')) {
						return i;
					}
				}
				return 0;
			}
			
			// Helper function to activate target tab
			function activateTargetTab(targetTab, targetPane) {
				if (!targetTab || !targetPane) return;
				
				// Remove active from all tabs and panes first
				var tabsWrapper = wrapper.closest('.atl-tabs-wrapper');
				tabsWrapper.querySelectorAll('.nav-link.active').forEach(function(btn) {
					btn.classList.remove('active');
					btn.setAttribute('aria-selected', 'false');
				});
				
				tabsWrapper.querySelectorAll('.tab-pane').forEach(function(pane) {
					pane.classList.remove('active', 'show');
					// Remove all inline styles completely
					pane.style.removeProperty('display');
					pane.style.removeProperty('opacity');
					pane.style.removeProperty('transform');
					pane.style.removeProperty('transition');
				});
				
				// Activate target tab button
				targetTab.classList.add('active');
				targetTab.setAttribute('aria-selected', 'true');
				
				// Prepare target pane for fade in - MUST set display: block FIRST
				targetPane.style.display = 'block';
				targetPane.classList.add('active', 'fade');
				targetPane.style.opacity = '0';
				targetPane.style.transform = 'translateY(10px)';
				targetPane.style.transition = 'opacity 0.4s ease-in-out, transform 0.4s ease-in-out';
				
				// Force reflow to ensure transition works
				void targetPane.offsetWidth;
				
				// Fade in new tab content
				setTimeout(function() {
					targetPane.classList.add('show');
					// Ensure display is still block when showing
					targetPane.style.display = 'block';
					targetPane.style.opacity = '1';
					targetPane.style.transform = 'translateY(0)';
				}, 10);
				
				// Trigger Bootstrap tab event if available (but ensure display stays block)
				if (typeof bootstrap !== 'undefined' && bootstrap.Tab) {
					var bsTab = new bootstrap.Tab(targetTab);
					bsTab.show();
					// Immediately after Bootstrap show, force display to block
					setTimeout(function() {
						if (targetPane.classList.contains('active') && targetPane.classList.contains('show')) {
							// Force display block - Bootstrap might have set it to none
							targetPane.style.setProperty('display', 'block', 'important');
						}
					}, 10);
					
					// Double check after a bit more time
					setTimeout(function() {
						if (targetPane.classList.contains('active') && targetPane.classList.contains('show')) {
							if (targetPane.style.display === 'none' || !targetPane.style.display) {
								targetPane.style.setProperty('display', 'block', 'important');
							}
						}
					}, 100);
				}
				
				// Scroll tab button into view
				setTimeout(function() {
					var tabRect = targetTab.getBoundingClientRect();
					var wrapperRect = wrapper.getBoundingClientRect();
					
					if (tabRect.left < wrapperRect.left) {
						wrapper.scrollBy({
							left: tabRect.left - wrapperRect.left - 20,
							behavior: 'smooth'
						});
					} else if (tabRect.right > wrapperRect.right) {
						wrapper.scrollBy({
							left: tabRect.right - wrapperRect.right + 20,
							behavior: 'smooth'
						});
					}
				}, 50);
			}
			
			// Activate tab and scroll to it with smooth transition
			function activateTab(index) {
				if (index < 0 || index >= tabButtons.length) return;
				
				var targetTab = tabButtons[index];
				var targetPaneId = targetTab.getAttribute('data-bs-target');
				var targetPane = d.querySelector(targetPaneId);
				var tabsWrapper = wrapper.closest('.atl-tabs-wrapper');
				var currentActivePane = tabsWrapper.querySelector('.tab-pane.active');
				var currentActiveTab = tabsWrapper.querySelector('.nav-link.active');
				
				// Check if clicking the same tab that's already active
				var isSameTab = currentActivePane === targetPane;
				
				// Fade out current tab content (only if different tab)
				if (currentActivePane && !isSameTab) {
					currentActivePane.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out';
					currentActivePane.style.opacity = '0';
					currentActivePane.style.transform = 'translateY(-10px)';
					
					// Wait for fade out to complete before switching
					setTimeout(function() {
						// Remove active class from current tab button
						if (currentActiveTab) {
							currentActiveTab.classList.remove('active');
							currentActiveTab.setAttribute('aria-selected', 'false');
						}
						
						// Remove active class from current pane and reset styles
						if (currentActivePane) {
							currentActivePane.classList.remove('active', 'show');
							// Remove all inline styles completely
							currentActivePane.style.removeProperty('display');
							currentActivePane.style.removeProperty('opacity');
							currentActivePane.style.removeProperty('transform');
							currentActivePane.style.removeProperty('transition');
						}
						
						// Activate new tab
						activateTargetTab(targetTab, targetPane);
					}, 300); // Wait for fade out (300ms)
				} else {
					// Same tab or no current active pane - activate directly
					if (currentActiveTab && currentActiveTab !== targetTab) {
						currentActiveTab.classList.remove('active');
						currentActiveTab.setAttribute('aria-selected', 'false');
					}
					
					// Reset and activate target tab
					activateTargetTab(targetTab, targetPane);
				}
			}
			
			// Scroll left - activate previous tab
			leftBtn.addEventListener('click', function() {
				var currentIndex = getActiveTabIndex();
				var prevIndex = currentIndex - 1;
				
				if (prevIndex >= 0) {
					activateTab(prevIndex);
				} else {
					// Already at first tab, just scroll left a bit
					wrapper.scrollBy({
						left: -200,
						behavior: 'smooth'
					});
				}
			});
			
			// Scroll right - activate next tab
			rightBtn.addEventListener('click', function() {
				var currentIndex = getActiveTabIndex();
				var nextIndex = currentIndex + 1;
				
				if (nextIndex < tabButtons.length) {
					activateTab(nextIndex);
				} else {
					// Already at last tab, just scroll right a bit
					wrapper.scrollBy({
						left: 200,
						behavior: 'smooth'
					});
				}
			});
			
			// Add smooth transition when clicking tab buttons directly
			tabButtons.forEach(function(btn, btnIndex) {
				btn.addEventListener('click', function(e) {
					var currentIndex = getActiveTabIndex();
					// Only handle if clicking different tab
					if (currentIndex !== btnIndex) {
						// Use our custom activateTab for smooth transition
						e.preventDefault();
						e.stopPropagation();
						activateTab(btnIndex);
					}
					// If clicking same tab, let Bootstrap handle it (no preventDefault)
				});
			});
			
			// Update buttons on scroll
			wrapper.addEventListener('scroll', updateScrollButtons);
			
			// Update buttons on window resize
			w.addEventListener('resize', updateScrollButtons);
			
			// Initial update
			updateScrollButtons();
			
			// Drag to scroll functionality
			var isDown = false;
			var startX;
			var scrollLeft;
			
			wrapper.addEventListener('mousedown', function(e) {
				isDown = true;
				wrapper.style.cursor = 'grabbing';
				startX = e.pageX - wrapper.offsetLeft;
				scrollLeft = wrapper.scrollLeft;
			});
			
			wrapper.addEventListener('mouseleave', function() {
				isDown = false;
				wrapper.style.cursor = 'grab';
			});
			
			wrapper.addEventListener('mouseup', function() {
				isDown = false;
				wrapper.style.cursor = 'grab';
			});
			
			wrapper.addEventListener('mousemove', function(e) {
				if (!isDown) return;
				e.preventDefault();
				var x = e.pageX - wrapper.offsetLeft;
				var walk = (x - startX) * 2; // Scroll speed multiplier
				wrapper.scrollLeft = scrollLeft - walk;
			});
		});
	}

	// Festival Calendar Description Expand/Collapse
	function initFestivalDescriptionExpand() {
		if (typeof jQuery === 'undefined') {
			setTimeout(initFestivalDescriptionExpand, 100);
			return;
		}

		var $ = jQuery;

		function initDescriptionExpand() {
			$('.atl-festival-description-wrapper').each(function() {
				var $wrapper = $(this);
				var $content = $wrapper.find('.atl-festival-description-content');
				var $btn = $wrapper.find('.atl-festival-expand-btn');

				// Đảm bảo content luôn có line-clamp 3 mặc định
				$content.css({
					'display': '-webkit-box',
					'-webkit-line-clamp': '3',
					'-webkit-box-orient': 'vertical',
					'overflow': 'hidden'
				});

				// Tạo clone để đo chiều cao thực của content
				var $tempClone = $content.clone();
				$tempClone.css({
					'display': 'block',
					'-webkit-line-clamp': 'unset',
					'-webkit-box-orient': 'unset',
					'overflow': 'visible',
					'position': 'absolute',
					'visibility': 'hidden',
					'width': $content.width() + 'px',
					'height': 'auto',
					'max-height': 'none',
					'z-index': '-1',
					'top': '-9999px',
					'left': '-9999px'
				});

				// Copy tất cả computed styles
				var computedStyle = window.getComputedStyle($content[0]);
				$tempClone.css({
					'font-size': computedStyle.fontSize,
					'font-family': computedStyle.fontFamily,
					'font-weight': computedStyle.fontWeight,
					'line-height': computedStyle.lineHeight,
					'padding': computedStyle.padding,
					'margin': computedStyle.margin,
					'box-sizing': computedStyle.boxSizing
				});

				// Thêm vào DOM để đo
				$content.after($tempClone);
				
				// Đo chiều cao thực
				var contentHeight = $tempClone[0].scrollHeight;
				var lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.5;
				var maxHeight = lineHeight * 3; // 3 dòng chính xác
				
				// Thêm buffer nhỏ (5px) để tránh trường hợp gần bằng
				var needsExpand = contentHeight > (maxHeight + 5);

				// Xóa clone
				$tempClone.remove();

				// Đảm bảo content luôn collapsed mặc định
				$wrapper.addClass('atl-description-collapsed');
				$content.removeClass('atl-description-expanded');

				if (needsExpand) {
					// Cần expand/collapse - chỉ hiển thị khi thực sự vượt quá 3 dòng
					$btn.show();
					$btn.find('.expand-icon').show();
					$btn.find('.collapse-icon').hide();
				} else {
					// Không cần, ẩn nút - content chỉ có 3 dòng hoặc ít hơn
					$btn.hide();
					$wrapper.removeClass('atl-description-collapsed');
				}
			});

			// Xử lý click vào ký tự [+] ở cuối câu
			$(document).on('click', '.atl-festival-expand-btn', function(e) {
				e.preventDefault();
				e.stopPropagation();

				var $btn = $(this);
				var $wrapper = $btn.closest('.atl-festival-description-wrapper');
				var $content = $wrapper.find('.atl-festival-description-content');
				var $expandIcon = $btn.find('.expand-icon');
				var $collapseIcon = $btn.find('.collapse-icon');

				if ($wrapper.hasClass('atl-description-collapsed')) {
					// Expand - hiển thị toàn bộ
					$wrapper.removeClass('atl-description-collapsed');
					$content.addClass('atl-description-expanded');
					$content.css({
						'display': 'block',
						'-webkit-line-clamp': 'unset',
						'overflow': 'visible'
					});
					$expandIcon.hide();
					$collapseIcon.show();
				} else {
					// Collapse - chỉ hiển thị 3 dòng
					$wrapper.addClass('atl-description-collapsed');
					$content.removeClass('atl-description-expanded');
					$content.css({
						'display': '-webkit-box',
						'-webkit-line-clamp': '3',
						'-webkit-box-orient': 'vertical',
						'overflow': 'hidden'
					});
					$expandIcon.show();
					$collapseIcon.hide();
				}
			});
		}

		// Chờ DOM ready
		if (typeof jQuery !== 'undefined') {
			jQuery(document).ready(function() {
				initDescriptionExpand();
			});
		}
	}

	function initContactSidebar() {
		var $contactSidebar = jQuery('.atl-contact-top');
		if ($contactSidebar.length === 0) return;

		function checkScroll() {
			var scrollTop = jQuery(window).scrollTop();
			var windowHeight = jQuery(window).height();
			
			// Kích hoạt khi scroll xuống khoảng 1 màn hình
			if (scrollTop >= windowHeight) {
				$contactSidebar.addClass('active');
			} else {
				$contactSidebar.removeClass('active');
			}
		}

		// Check ngay khi load
		checkScroll();

		// Check khi scroll
		jQuery(window).on('scroll', function() {
			checkScroll();
		});

		// Check khi resize
		jQuery(window).on('resize', function() {
			checkScroll();
		});
	}

	// Agent Register Form Handler
	function initAgentRegister() {
		if (typeof jQuery === 'undefined') {
			setTimeout(initAgentRegister, 100);
			return;
		}

		var $ = jQuery;
		
		// Set overlay loading
		function setOverlay(form, show) {
			var $container = $(form).closest('.contact-form-outer');
			if (!$container.length) {
				$container = $(form);
			}
			
			var container = $container[0];
			if (!container) return;
			
			if (w.getComputedStyle(container).position === 'static') {
				container.style.position = 'relative';
			}
			
			var overlay = container.querySelector('.atl-form-loading-overlay');
			if (!overlay) {
				overlay = d.createElement('div');
				overlay.className = 'atl-form-loading-overlay';
				overlay.innerHTML = '<div class="atl-loading-pic"><div class="loader"></div></div>';
				container.appendChild(overlay);
			}
			
			overlay.style.display = show ? 'flex' : 'none';
		}
		
		// Show success message
		function showSuccess(displayName) {
			var $registerForm = $('#atl-register-form');
			var $form = $('#atl-agent-register-form');
			var $successMessage = $('#atl-register-success');
			
			// Hide form
			$form.hide();
			
			// Set display name
			$('#atl-register-success-name').text(displayName || '');
			
			// Show success message
			$successMessage.show();
			
			// Scroll to success message
			$('html, body').animate({
				scrollTop: $registerForm.offset().top - 100
			}, 500);
		}
		
		// Handle form submission
		$(document).on('submit', '#atl-agent-register-form', function(e) {
			e.preventDefault();
			
			var $form = $(this);
			var $submitBtn = $form.find('.atl-register-submit-btn');
			var $messageDiv = $('#atl-register-message');
			var originalBtnText = $submitBtn.text();
			
			// Clear previous messages
			$messageDiv.hide().removeClass('alert-success alert-danger').html('');
			
			// Get email value
			var email = $form.find('[name="email"]').val();

			// Validate Name / Email trước khi gửi
			if (w.ATLValidation) {
				var registerErrors = {};
				w.ATLValidation.checkNameField($form[0], 'displayName', 'Operator Name', registerErrors, true);
				w.ATLValidation.checkNameField($form[0], 'contactName', 'Contact Name', registerErrors);
				w.ATLValidation.checkEmailField($form[0], 'email', registerErrors);

				var registerErrorKeys = Object.keys(registerErrors);
				if (registerErrorKeys.length) {
					$messageDiv
						.addClass('alert alert-danger')
						.html(registerErrorKeys.map(function (key) { return registerErrors[key]; }).join('<br>'))
						.show();
					$('html, body').animate({
						scrollTop: $messageDiv.offset().top - 100
					}, 500);
					return false;
				}
			}
			
			// Set button loading
			$submitBtn.prop('disabled', true).text('Submitting...');
			
			// Show overlay loading
			setOverlay($form[0], true);
			
			// Prepare form data - username will be same as email
			var formData = $form.serialize();
			// Add username = email to formData
			if (email) {
				formData += '&username=' + encodeURIComponent(email);
			}
			formData += '&action=atl_agent_register';
			
			// Get AJAX config
			var ajaxUrl = (typeof atlConfigAjax !== 'undefined' && atlConfigAjax.ajax_url) 
				? atlConfigAjax.ajax_url 
				: '/wp-admin/admin-ajax.php';
			
			// Send AJAX request
			$.ajax({
				url: ajaxUrl,
				type: 'POST',
				data: formData,
				dataType: 'json',
				success: function(response) {
					// Hide overlay
					setOverlay($form[0], false);
					$submitBtn.prop('disabled', false).text(originalBtnText);
					
					if (response && response.success) {
						// Get display name from response or form
						var displayName = (response.data && response.data.displayName) 
							? response.data.displayName 
							: $form.find('[name="displayName"]').val();
						
						// Show success message
						showSuccess(displayName);
					} else {
						// Show error message
						var errorMsg = 'Registration failed. Please try again.';
						if (response && response.data && response.data.message) {
							errorMsg = response.data.message;
						}
						
						$messageDiv
							.addClass('alert alert-danger')
							.html(errorMsg)
							.show();
						
						// Scroll to message
						$('html, body').animate({
							scrollTop: $messageDiv.offset().top - 100
						}, 500);
					}
				},
				error: function(xhr, status, error) {
					// Hide overlay
					setOverlay($form[0], false);
					$submitBtn.prop('disabled', false).text(originalBtnText);
					
					var errorMsg = 'Something went wrong. Please try again later.';
					if (xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) {
						errorMsg = xhr.responseJSON.data.message;
					}
					
					$messageDiv
						.addClass('alert alert-danger')
						.html(errorMsg)
						.show();
					
					// Scroll to message
					$('html, body').animate({
						scrollTop: $messageDiv.offset().top - 100
					}, 500);
				}
			});
			
			return false;
		});
		
		// Handle "Login now" link from success message
		$(document).on('click', '.atl-toggle-login-from-success', function(e) {
			e.preventDefault();
			e.stopPropagation();
			
			var $loginForm = $('#atl-login-form');
			var $registerForm = $('#atl-register-form');
			var $successMessage = $('#atl-register-success');
			
			// Hide register form and success message
			if ($registerForm.length) {
				$registerForm.hide();
			}
			if ($successMessage.length) {
				$successMessage.hide();
			}
			
			// Show login form
			if ($loginForm.length) {
				$loginForm.show();
			}
		});
	}

	// Agent Login Form Handler
	function initAgentLogin() {
		if (typeof jQuery === 'undefined') {
			setTimeout(initAgentLogin, 100);
			return;
		}

		var $ = jQuery;
		
		// Set overlay loading
		function setOverlay(form, show) {
			var $container = $(form).closest('.contact-form-outer');
			if (!$container.length) {
				$container = $(form);
			}
			
			var container = $container[0];
			if (!container) return;
			
			if (w.getComputedStyle(container).position === 'static') {
				container.style.position = 'relative';
			}
			
			var overlay = container.querySelector('.atl-form-loading-overlay');
			if (!overlay) {
				overlay = d.createElement('div');
				overlay.className = 'atl-form-loading-overlay';
				overlay.innerHTML = '<div class="atl-loading-pic"><div class="loader"></div></div>';
				container.appendChild(overlay);
			}
			
			overlay.style.display = show ? 'flex' : 'none';
		}
		
		// Handle form submission
		$(document).on('submit', '#atl-agent-login-form', function(e) {
			e.preventDefault();
			
			var $form = $(this);
			var $submitBtn = $form.find('.atl-login-submit-btn');
			var $messageDiv = $('#atl-login-message');
			var originalBtnText = $submitBtn.text();
			
			// Clear previous messages
			$messageDiv.hide().removeClass('alert-success alert-danger').html('');
			
			// Set button loading
			$submitBtn.prop('disabled', true).text('Logging in...');
			
			// Show overlay loading
			setOverlay($form[0], true);
			
			// Prepare form data
			var formData = $form.serialize();
			formData += '&action=atl_agent_login';
			
			// Get AJAX config
			var ajaxUrl = (typeof atlConfigAjax !== 'undefined' && atlConfigAjax.ajax_url) 
				? atlConfigAjax.ajax_url 
				: '/wp-admin/admin-ajax.php';
			
			// Send AJAX request
			$.ajax({
				url: ajaxUrl,
				type: 'POST',
				data: formData,
				dataType: 'json',
				success: function(response) {
					// Hide overlay
					setOverlay($form[0], false);
					$submitBtn.prop('disabled', false).text(originalBtnText);
					
					if (response && response.success && response.data) {
						// Save to localStorage
						try {
							var userInfo = JSON.stringify(response.data);
							localStorage.setItem('atl_asiatraveldmc_userinfo', userInfo);
							
							// Redirect to https://asiatravelleisure.com
							window.location.href = 'https://asiatravelleisure.com';
						} catch (storageError) {
							// If localStorage fails, show error
							$messageDiv
								.addClass('alert alert-danger')
								.html('Failed to save login information. Please try again.')
								.show();
						}
					} else {
						// Show error message
						var errorMsg = 'Login failed. Please try again.';
						if (response && response.data && response.data.message) {
							errorMsg = response.data.message;
						}
						
						$messageDiv
							.addClass('alert alert-danger')
							.html(errorMsg)
							.show();
						
						// Scroll to message
						$('html, body').animate({
							scrollTop: $messageDiv.offset().top - 100
						}, 500);
					}
				},
				error: function(xhr, status, error) {
					// Hide overlay
					setOverlay($form[0], false);
					$submitBtn.prop('disabled', false).text(originalBtnText);
					
					var errorMsg = 'Something went wrong. Please try again later.';
					if (xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) {
						errorMsg = xhr.responseJSON.data.message;
					}
					
					$messageDiv
						.addClass('alert alert-danger')
						.html(errorMsg)
						.show();
					
					// Scroll to message
					$('html, body').animate({
						scrollTop: $messageDiv.offset().top - 100
					}, 500);
				}
			});
			
			return false;
		});
	}

	/** Popup "Customise your holiday": sau load (delay từ Theme Options); đóng overlay / X / Escape; phone+date init lần đầu mở; gửi AJAX giống customize tour. */
	function initHolidayEnquiryPopup() {
		var root = d.getElementById('atl-holiday-enquiry-popup');
		if (!root) return;

		var delayMs = 8000;
		if (w.atlConfigAjax && w.atlConfigAjax.holiday_popup_open_delay_ms != null) {
			var parsedDelay = parseInt(w.atlConfigAjax.holiday_popup_open_delay_ms, 10);
			if (!isNaN(parsedDelay) && parsedDelay >= 0) {
				delayMs = parsedDelay;
			}
		}
		var popupWidgetsReady = false;

		function initPopupWidgetsOnce() {
			if (popupWidgetsReady) return;
			popupWidgetsReady = true;
			initPhone('#atl-holiday-popup-phone-input', false);
			initHolidayPopupTravelDate();
			countryDetection.syncHolidayPopupFromDetectedCountry();
		}

		function openPopup() {
			root.removeAttribute('hidden');
			root.setAttribute('aria-hidden', 'false');
			root.classList.add('is-open');
			d.body.classList.add('atl-holiday-popup-open');
			initPopupWidgetsOnce();
		}

		function closePopup() {
			root.classList.remove('is-open');
			root.setAttribute('aria-hidden', 'true');
			root.setAttribute('hidden', '');
			d.body.classList.remove('atl-holiday-popup-open');
		}

		function onKeydown(e) {
			if (e.key === 'Escape' && root.classList.contains('is-open')) {
				closePopup();
			}
		}

		var closers = root.querySelectorAll('[data-atl-holiday-popup-close]');
		for (var i = 0; i < closers.length; i++) {
			closers[i].addEventListener('click', function(ev) {
				ev.preventDefault();
				closePopup();
			});
		}

		d.addEventListener('keydown', onKeydown);

		// Manual trigger (e.g. mobile action bar "Plan Your Tour")
		var openedByUser = false;
		var openers = d.querySelectorAll('[data-atl-holiday-popup-open]');
		for (var j = 0; j < openers.length; j++) {
			openers[j].addEventListener('click', function(ev) {
				ev.preventDefault();
				openedByUser = true;
				openPopup();
			});
		}

		function holidayPopupTrackGA(bookingId, email, phone, totalValue) {
			if (!w.atlCustomScripts) {
				return;
			}
			var popupScript = w.atlCustomScripts.js_after_submit_popup_form || w.atlCustomScripts.page_after_submit_js;
			if (!popupScript) {
				return;
			}
			var script = popupScript
				.replace(/'USER_EMAIL'/g, '\'' + String(email) + '\'')
				.replace(/'USER_PHONE'/g, '\'' + String(phone) + '\'')
				.replace(/'REQUESTCODE'/g, '\'' + String(bookingId || '') + '\'')
				.replace(/TOTALVALUE/g, String(totalValue !== undefined ? totalValue : 0));
			try {
				console.log(script);
				eval(script);
			} catch (err) {
				console.error('ATL holiday popup tracking error', err);
			}
		}

		var form = d.getElementById('atl-holiday-enquiry-form');
		if (form) {
			var feedbackEl = d.getElementById('atl-holiday-popup-feedback');
			var successEl = d.getElementById('atl-holiday-popup-success');
			var submitBtn = form.querySelector('.atl-holiday-popup__submit');
			var inner = root.querySelector('.atl-holiday-popup__inner');

			function clearHolidayPopupErrors() {
				if (feedbackEl) {
					feedbackEl.textContent = '';
					feedbackEl.setAttribute('hidden', '');
					feedbackEl.classList.remove('is-visible');
				}
				form.querySelectorAll('.atl-holiday-popup__field-error').forEach(function(el) {
					el.remove();
				});
				form.querySelectorAll('.atl-holiday-popup__control, .atl-holiday-popup__textarea').forEach(function(el) {
					el.classList.remove('atl-field-has-error');
				});
				form.querySelectorAll('input[name="countries[]"]').forEach(function(el) {
					el.classList.remove('atl-field-has-error');
				});
			}

			function renderHolidayPopupErrors(errors, message, allowHtml) {
				errors = errors || {};
				if (message && feedbackEl) {
					// allowHtml chỉ dùng cho nội dung do admin cấu hình trong Theme Options.
					if (allowHtml) {
						feedbackEl.innerHTML = message;
					} else {
						feedbackEl.textContent = message;
					}
					feedbackEl.removeAttribute('hidden');
					feedbackEl.classList.add('is-visible');
				}
				Object.keys(errors).forEach(function(field) {
					var text = errors[field];
					var group = null;
					var input = form.querySelector('[name="' + field + '"]');
					if (field === 'countries') {
						group = form.querySelector('.atl-holiday-popup__visit');
					} else if (input) {
						group = input.closest('.atl-holiday-popup__field');
					}
					if (group && text) {
						var err = d.createElement('div');
						err.className = 'atl-holiday-popup__field-error';
						err.textContent = text;
						group.appendChild(err);
					}
					if (input) {
						input.classList.add('atl-field-has-error');
					}
					if (field === 'countries') {
						form.querySelectorAll('input[name="countries[]"]').forEach(function(cb) {
							cb.classList.add('atl-field-has-error');
						});
					}
				});
			}

			function setHolidayPopupLoading(show) {
				if (!inner) {
					return;
				}
				if (getComputedStyle(inner).position === 'static') {
					inner.style.position = 'relative';
				}
				var overlay = inner.querySelector('.atl-form-loading-overlay');
				if (!overlay) {
					overlay = d.createElement('div');
					overlay.className = 'atl-form-loading-overlay';
					overlay.setAttribute('aria-hidden', 'true');
					overlay.innerHTML = '<div class="atl-loading-pic"><div class="loader"></div></div>';
					inner.appendChild(overlay);
				}
				overlay.style.display = show ? 'flex' : 'none';
			}

			/** Nội dung thông báo chặn submit (HTML từ Theme Options): ưu tiên Theme Options, fallback mặc định. */
			function getHolidayPopupBlockedMessage() {
				var configured = (w.atlConfigAjax && w.atlConfigAjax.submission_blocked_message)
					? String(w.atlConfigAjax.submission_blocked_message).trim()
					: '';
				return configured || '<p>We couldn’t complete your request right now. Please try again later.</p>';
			}

			/** Ẩn toàn bộ form và chỉ hiển thị panel lỗi hệ thống. */
			function showHolidayPopupBlocked(message) {
				var errorEl = d.getElementById('atl-holiday-popup-error');
				var text = (message && String(message).trim()) ? String(message).trim() : getHolidayPopupBlockedMessage();
				clearHolidayPopupErrors();
				setHolidayPopupLoading(false);

				if (!errorEl) {
					renderHolidayPopupErrors({}, text, true);
					return;
				}

				var messageEl = d.getElementById('atl-holiday-popup-error-message');
				if (messageEl) {
					// Nội dung do admin cấu hình (đã lọc wp_kses_post ở PHP) — cho phép HTML.
					messageEl.innerHTML = text;
				}

				form.style.display = 'none';
				if (successEl) {
					successEl.style.display = 'none';
					successEl.setAttribute('hidden', '');
				}
				errorEl.style.display = 'block';
				errorEl.removeAttribute('hidden');
				try {
					errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
				} catch (e3) {
					// ignore
				}
			}

			function validateHolidayPopupClient(f) {
				var errors = {};
				var required = [
					{ name: 'days', label: 'Number of days' },
					{ name: 'hotel_category', label: 'Hotel category' },
					{ name: 'travellers', label: 'Number of travellers' },
					{ name: 'travel_date', label: 'Travel date' },
					{ name: 'your_name', label: 'Your name' },
					{ name: 'email', label: 'Email' },
					{ name: 'email_confirm', label: 'Confirm email' },
					{ name: 'phone', label: 'Phone number' },
					{ name: 'nationality', label: 'Nationality' }
				];
				required.forEach(function(field) {
					var inp = f.querySelector('[name="' + field.name + '"]');
					if (!inp || !String(inp.value).trim()) {
						errors[field.name] = field.label + ' is required.';
					}
				});
				var checked = f.querySelectorAll('input[name="countries[]"]:checked');
				if (!checked.length) {
					errors.countries = 'Please select at least one country to visit.';
				}
				if (w.ATLValidation) {
					w.ATLValidation.checkNameField(f, 'your_name', 'Your name', errors);
					w.ATLValidation.checkEmailField(f, 'email', errors);
				}

				var email = f.querySelector('[name="email"]');
				var em2 = f.querySelector('[name="email_confirm"]');
				if (email && em2 && email.value !== em2.value) {
					errors.email_confirm = 'Email addresses do not match.';
				}
				var travelDateInput = f.querySelector('[name="travel_date"]');
				if (travelDateInput && String(travelDateInput.value).trim()) {
					var minTravelDate = getMinHolidayTravelDate();
					var selectedDate = null;
					if (travelDateInput._atlPikaday && typeof travelDateInput._atlPikaday.getDate === 'function') {
						selectedDate = travelDateInput._atlPikaday.getDate();
					}
					if (!selectedDate) {
						selectedDate = new Date(travelDateInput.value);
					}
					if (!(selectedDate instanceof Date) || isNaN(selectedDate.getTime())) {
						errors.travel_date = 'Please select a valid travel date.';
					} else {
						selectedDate.setHours(0, 0, 0, 0);
						if (selectedDate < minTravelDate) {
							errors.travel_date = 'Travel date must be at least 3 days from today.';
						}
					}
				}
				return errors;
			}

			form.addEventListener('submit', function(ev) {
				ev.preventDefault();
				clearHolidayPopupErrors();

				var clientErrors = validateHolidayPopupClient(form);
				if (Object.keys(clientErrors).length) {
					renderHolidayPopupErrors(clientErrors);
					return;
				}

				// Chặn submit khi số khách là 1 người — check sau cùng, khi mọi trường đã hợp lệ.
				var travellersEl = form.querySelector('[name="travellers"]');
				if (travellersEl && parseInt(String(travellersEl.value).trim(), 10) === 1) {
					showHolidayPopupBlocked();
					return;
				}

				setHolidayPopupLoading(true);
				if (submitBtn) {
					submitBtn.disabled = true;
					submitBtn.setAttribute('data-atl-prev-label', submitBtn.textContent);
					submitBtn.textContent = 'Sending...';
				}

				var data = new FormData(form);
				var phoneInput = d.getElementById('atl-holiday-popup-phone-input');
				var itiInstanceForSubmit = null;
				if (phoneInput && w.intlTelInputGlobals && w.intlTelInputGlobals.getInstance) {
					itiInstanceForSubmit = w.intlTelInputGlobals.getInstance(phoneInput);
				}
				if (!itiInstanceForSubmit && itiHolidayPopupInstance) {
					itiInstanceForSubmit = itiHolidayPopupInstance;
				}
				if (itiInstanceForSubmit) {
					var phoneFull = getPhoneE164ForTracking(phoneInput);
					if (phoneFull) {
						data.append('phone-full', phoneFull);
					}
					var country = itiInstanceForSubmit.getSelectedCountryData();
					if (country) {
						data.append('phone-country-code', '+' + country.dialCode);
						data.append('phone-country-iso', country.iso2);
					}
				}

				try {
					var ipInfo = w.localStorage.getItem('atl_info_ip');
					if (ipInfo) {
						data.append('dataIpUser', ipInfo);
					}
				} catch (e1) {
					console.warn('Cannot read IP cache', e1);
				}

				data.append('action', 'atl_submit_holiday_enquiry');

				var ajaxUrl = (w.atlConfigAjax && w.atlConfigAjax.ajax_url) ? w.atlConfigAjax.ajax_url : '/wp-admin/admin-ajax.php';

				var emailVal = form.querySelector('[name="email"]');
				emailVal = emailVal ? emailVal.value : '';
				var phoneVal = getPhoneE164ForTracking(phoneInput);

				fetch(ajaxUrl, {
					method: 'POST',
					body: data,
					credentials: 'same-origin'
				})
					.then(function(res) {
						return res.json();
					})
					.then(function(json) {
						setHolidayPopupLoading(false);
						if (submitBtn) {
							submitBtn.disabled = false;
							var prev = submitBtn.getAttribute('data-atl-prev-label');
							if (prev) {
								submitBtn.textContent = prev;
							}
						}

						if (json.success) {
							form.style.display = 'none';
							if (successEl) {
								var line = d.getElementById('atl-holiday-popup-success-message');
								if (line && json.data && json.data.message) {
									line.textContent = json.data.message;
								}
								successEl.style.display = 'block';
								successEl.removeAttribute('hidden');
								try {
									successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
								} catch (e2) {
									// ignore
								}
							}
							holidayPopupTrackGA(
								json.data && json.data.booking_id,
								emailVal,
								phoneVal,
								json.data && json.data.total_value
							);
							return;
						}

						if (json.data && json.data.blocked) {
							showHolidayPopupBlocked(json.data.message);
							return;
						}

						renderHolidayPopupErrors(
							json.data && json.data.errors,
							json.data && json.data.message
						);
					})
					.catch(function() {
						setHolidayPopupLoading(false);
						if (submitBtn) {
							submitBtn.disabled = false;
							var prev2 = submitBtn.getAttribute('data-atl-prev-label');
							if (prev2) {
								submitBtn.textContent = prev2;
							}
						}
						renderHolidayPopupErrors({}, 'Something went wrong. Please try again.');
					});
			});
		}

		function isHolidayPopupBlockedByCountry() {
			if (typeof w.atlConfigAjax === 'undefined') {
				return false;
			}
			if (w.atlConfigAjax.holiday_popup_skip_geo) {
				return false;
			}
			var codes = w.atlConfigAjax.holiday_popup_hide_country_codes;
			if (!codes || !codes.length) {
				return false;
			}
			try {
				var raw = w.localStorage.getItem('atl_info_ip');
				if (!raw) {
					return false;
				}
				var data = JSON.parse(raw);
				var cc = data && data.countryCode ? String(data.countryCode).toUpperCase() : '';
				if (!cc) {
					return false;
				}
				for (var cg = 0; cg < codes.length; cg++) {
					if (String(codes[cg]).toUpperCase() === cc) {
						return true;
					}
				}
			} catch (eGeo) {
				return false;
			}
			return false;
		}

		w.setTimeout(function() {
			if (openedByUser || isHolidayPopupBlockedByCountry()) {
				return;
			}
			openPopup();
		}, delayMs);
	}

	/**
	 * Footer: mobile viewport max 767px — trượt từng địa chỉ; desktop giữ lưới 3 cột.
	 */
	function initFooterAddressSlider() {
		var root = d.querySelector('[data-atl-footer-address-slider]');
		if (!root) return;

		var viewport = root.querySelector('.atl-footer-address-slider__viewport');
		var track = root.querySelector('.atl-footer-address-slider__track');
		var slides = root.querySelectorAll('.atl-footer-address-slider__slide');
		var btnPrev = root.querySelector('.swiper-button-prev');
		var btnNext = root.querySelector('.swiper-button-next');

		if (!viewport || !track || slides.length === 0) return;

		var index = 0;
		var count = slides.length;

		function viewportStepPx() {
			var r = viewport.getBoundingClientRect();
			return Math.max(0, Math.round(r.width));
		}

		function syncSlideWidths() {
			var i;
			if (!isFooterSliderMobile()) {
				for (i = 0; i < slides.length; i++) {
					slides[i].style.flexBasis = '';
					slides[i].style.width = '';
					slides[i].style.minWidth = '';
					slides[i].style.maxWidth = '';
				}
				return;
			}
			var step = viewportStepPx();
			if (!step) return;
			for (i = 0; i < slides.length; i++) {
				var s = slides[i];
				s.style.flex = '0 0 ' + step + 'px';
				s.style.width = step + 'px';
				s.style.minWidth = step + 'px';
				s.style.maxWidth = step + 'px';
			}
		}

		function isFooterSliderMobile() {
			return w.matchMedia('(max-width: 767.98px)').matches;
		}

		function clampIndex(i) {
			if (count <= 1) return 0;
			if (i < 0) return 0;
			if (i >= count) return count - 1;
			return i;
		}

		function updateAriaHidden() {
			for (var si = 0; si < slides.length; si++) {
				slides[si].setAttribute('aria-hidden', si === index ? 'false' : 'true');
			}
		}

		function syncButtons() {
			if (btnPrev) {
				var atStart = index <= 0;
				btnPrev.disabled = atStart;
				btnPrev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
			}
			if (btnNext) {
				var atEnd = index >= count - 1;
				btnNext.disabled = atEnd;
				btnNext.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
			}
		}

		function applyTransform() {
			syncSlideWidths();
			if (!isFooterSliderMobile()) {
				track.style.transform = '';
				return;
			}
			var step = viewportStepPx();
			if (step <= 0) return;
			track.style.transform = 'translateX(' + (-index * step) + 'px)';
			updateAriaHidden();
			syncButtons();
		}

		function go(delta) {
			if (!isFooterSliderMobile() || count <= 1) return;
			index = clampIndex(index + delta);
			applyTransform();
		}

		var touchStartX = null;
		viewport.addEventListener('touchstart', function(ev) {
			if (!isFooterSliderMobile() || !ev.changedTouches || !ev.changedTouches.length) return;
			touchStartX = ev.changedTouches[0].clientX;
		}, { passive: true });

		viewport.addEventListener('touchend', function(ev) {
			if (touchStartX === null || !isFooterSliderMobile()) return;
			if (!ev.changedTouches || !ev.changedTouches.length) return;
			var dx = ev.changedTouches[0].clientX - touchStartX;
			touchStartX = null;
			if (Math.abs(dx) < 48) return;
			if (dx < 0) go(1);
			else go(-1);
		}, { passive: true });

		if (btnPrev) btnPrev.addEventListener('click', function() { go(-1); });
		if (btnNext) btnNext.addEventListener('click', function() { go(1); });

		root.addEventListener('keydown', function(ev) {
			if (!isFooterSliderMobile() || count <= 1) return;
			var k = ev.key;
			if (k === 'ArrowLeft') {
				ev.preventDefault();
				go(-1);
			} else if (k === 'ArrowRight') {
				ev.preventDefault();
				go(1);
			}
		});

		var resizeScheduled = false;
		var scheduleFrame = typeof w.requestAnimationFrame === 'function'
			? w.requestAnimationFrame.bind(w)
			: function(cb) { return w.setTimeout(cb, 16); };
		function onResize() {
			index = clampIndex(index);
			applyTransform();
		}
		w.addEventListener('resize', function() {
			if (resizeScheduled) return;
			resizeScheduled = true;
			scheduleFrame(function() {
				resizeScheduled = false;
				onResize();
			});
		});

		if (typeof ResizeObserver === 'function') {
			var roFooterAddr = new ResizeObserver(function() {
				if (resizeScheduled) return;
				resizeScheduled = true;
				scheduleFrame(function() {
					resizeScheduled = false;
					onResize();
				});
			});
			roFooterAddr.observe(viewport);
		}

		index = 0;
		updateAriaHidden();
		syncButtons();
		applyTransform();
	}

	function init() {
		initPhone('#atl-phone-input');
		initFooterAddressSlider();
		initDatepicker('#atl-travel-date-input');
		
		// Initialize country detection with delay to ensure phone input is ready
		setTimeout(function() {
			countryDetection.init();
		}, 500);

		function initGalleryLoadMore() {
			var $loadMoreBtn = jQuery('.atl-gallery-load-more-btn');
			if ($loadMoreBtn.length === 0) return;
			
			var $galleryItems = jQuery('.atl-gallery-item');
			var perPage = parseInt($loadMoreBtn.data('per-page')) || 6;
			var total = parseInt($loadMoreBtn.data('total')) || 0;
			var currentVisible = perPage;
			
			$galleryItems.each(function(index) {
				if (index >= perPage) {
					jQuery(this).addClass('atl-gallery-item-hidden');
				}
			});
			
			$loadMoreBtn.on('click', function(e) {
				e.preventDefault();
				
				var $hiddenItems = jQuery('.atl-gallery-item-hidden');
				var itemsToShow = Math.min(perPage, $hiddenItems.length);
				
				if (itemsToShow > 0) {
					$hiddenItems.slice(0, itemsToShow).each(function() {
						var $item = jQuery(this);
						var $link = $item.find('.project-view-btn');
						var galleryId = $link.data('gallery-id');
						
						if (galleryId && !$link.attr('rel')) {
							$link.attr('rel', 'atl-gallery-' + galleryId);
						}
						
						$item.removeClass('atl-gallery-item-hidden').fadeIn(300);
					});
					
					currentVisible += itemsToShow;
					
					if (typeof lc_lightbox !== 'undefined') {
						var $existingElems = jQuery('.elem.project-view-btn[rel^="atl-gallery-"]');
						if ($existingElems.length > 0) {
							lc_lightbox('.elem.project-view-btn[rel^="atl-gallery-"]', {
								wrap_class: 'lcl_fade_oc',
								gallery: true,
								thumb_attr: 'data-lcl-thumb',
								skin: 'minimal',
								radius: 0,
								padding: 0,
								border_w: 0,
								live_elements: true
							});
						}
					}
					
					if (currentVisible >= total) {
						$loadMoreBtn.fadeOut(300);
					}
				}
			});
		}

		function initGalleryFilterRel() {
			var $masonryFilter = jQuery('.masonry-filter');
			var $masonryWrap = jQuery('.masonry-wrap');
			
			if ($masonryFilter.length === 0 || $masonryWrap.length === 0) return;
			
			var $galleryLinks = $masonryWrap.find('.atl-gallery-view-btn');
			$galleryLinks.removeClass('elem');
			$galleryLinks.addClass('atl-gallery-filter-elem');
			
			function updateRelAttributes(filterValue) {
				var $allGalleryLinks = $masonryWrap.find('.atl-gallery-view-btn');
				$allGalleryLinks.removeAttr('rel');
				
				var $visibleItems = $masonryWrap.find('.masonry-item:visible');
				var $visibleGalleryLinks = $visibleItems.find('.atl-gallery-view-btn');
				
				var relValue = 'all-gallery';
				
				if (filterValue === '*' || filterValue === '') {
					relValue = 'all-gallery';
					$visibleGalleryLinks.attr('rel', relValue);
				} else {
					var categoryClass = filterValue.replace(/^\./, '');
					if (categoryClass) {
						relValue = 'atl-filter-' + categoryClass;
						$visibleGalleryLinks.each(function() {
							var $link = jQuery(this);
							var itemCategoryClass = $link.data('category-class') || '';
							if (itemCategoryClass === categoryClass) {
								$link.attr('rel', relValue);
							}
						});
					} else {
						$visibleGalleryLinks.attr('rel', 'all-gallery');
					}
				}
				
				if (typeof lc_lightbox !== 'undefined') {
					$masonryWrap.find('.atl-gallery-view-btn').off('click.lcl');
					
					$masonryWrap.find('.atl-gallery-view-btn').each(function() {
						var $link = jQuery(this);
						$link.removeData('lcl_settings');
						$link.removeData('lcl_vars');
					});
					
					setTimeout(function() {
						var selector = '.masonry-wrap .masonry-item:visible .atl-gallery-view-btn[rel="' + relValue + '"]';
						var $visibleWithRel = jQuery(selector);
						
						if ($visibleWithRel.length > 0) {
							lc_lightbox(selector, {
								wrap_class: 'lcl_fade_oc',
								gallery: true,
								thumb_attr: 'data-lcl-thumb',
								skin: 'minimal',
								radius: 0,
								padding: 0,
								border_w: 0
							});
						}
					}, 200);
				}
			}
			
			$masonryFilter.on('click', 'li', function() {
				var $li = jQuery(this);
				var filterValue = $li.find('a').data('filter') || '*';
				
				setTimeout(function() {
					updateRelAttributes(filterValue);
				}, 1100);
			});
			
			var $activeFilter = $masonryFilter.find('li.active');
			if ($activeFilter.length > 0) {
				var initialFilter = $activeFilter.find('a').data('filter') || '*';
				setTimeout(function() {
					updateRelAttributes(initialFilter);
				}, 800);
			} else {
				setTimeout(function() {
					updateRelAttributes('*');
				}, 800);
			}
		}

		if (typeof jQuery !== 'undefined') {
			jQuery(document).ready(function() {
				initMobileMenu();
				initHomeGallerySlider();
				initAtlGallerySlider();
				initWhyChooseUsSlider();
				initLoginRegisterToggle();
				initFestivalTabsScroll();
				initFestivalDescriptionExpand();
				initContactSidebar();
				initAgentRegister();
				initAgentLogin();
				initGalleryLoadMore();
				initGalleryFilterRel();
				initRandomSalesConsultantAvatars();
				initProfileTestimonialsSlider();
				initProfileServicesSlider();
				initProfileProcessSlider();
				initAboutSlider();
				initDestinationsSlider();
				initServicesSlider();
				initServicesIntroToggle();
				initOurInfoIntroToggle();
				initBlogsSlider();
				initTourDurationFilter();
				initFaqsToggleAll();
			});
		} else {
			setTimeout(function() {
				if (typeof jQuery !== 'undefined') {
					jQuery(document).ready(function() {
						initMobileMenu();
						initHomeGallerySlider();
						initAtlGallerySlider();
						initWhyChooseUsSlider();
						initLoginRegisterToggle();
						initFestivalTabsScroll();
						initFestivalDescriptionExpand();
						initContactSidebar();
						initAgentRegister();
						initAgentLogin();
						initGalleryLoadMore();
						initGalleryFilterRel();
						initRandomSalesConsultantAvatars();
						initProfileTestimonialsSlider();
						initProfileServicesSlider();
						initProfileProcessSlider();
						initAboutSlider();
						initDestinationsSlider();
						initServicesSlider();
						initServicesIntroToggle();
						initOurInfoIntroToggle();
						initBlogsSlider();
						initTourDurationFilter();
						initFaqsToggleAll();
					});
				}
			}, 100);
		}
		initHolidayEnquiryPopup();
	}

	// Initialize Destinations Slider (separate from filter slider)
	function initDestinationsSlider() {
		var destinationsSwiperEl = d.querySelector('.atl-destinations-swiper');
		if (!destinationsSwiperEl || !w.Swiper) return;
		
		var destinationsConfig = {
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 20,
			autoHeight: false,
			loop: true,
			grabCursor: true,
			autoplay: true,
			breakpoints: {
				0: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 20
				},
				575: {
					slidesPerView: 2,
					slidesPerGroup: 1,
					spaceBetween: 30
				},
				991: {
					slidesPerView: 3,
					slidesPerGroup: 1,
					spaceBetween: 30
				},
				1366: {
					slidesPerView: 4,
					slidesPerGroup: 1,
					spaceBetween: 25
				}
			},
			navigation: {
				nextEl: destinationsSwiperEl.querySelector('.swiper-button-next'),
				prevEl: destinationsSwiperEl.querySelector('.swiper-button-prev')
			}
		};
		
		new w.Swiper(destinationsSwiperEl, destinationsConfig);
	}

	// Initialize Services Slider (Home - Services shortcode)
	function initServicesSlider() {
		var servicesSwiperEl = d.querySelector('.atl-services-swiper');
		if (!servicesSwiperEl || !w.Swiper) return;

		var servicesConfig = {
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 16,
			autoHeight: false,
			loop: true,
			grabCursor: true,
			autoplay: true,
			breakpoints: {
				0: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 16
				},
				991: {
					slidesPerView: 3,
					slidesPerGroup: 1,
					spaceBetween: 30
				},
				1366: {
					slidesPerView: 3,
					slidesPerGroup: 1,
					spaceBetween: 25
				}
			},
			navigation: {
				nextEl: servicesSwiperEl.querySelector('.swiper-button-next'),
				prevEl: servicesSwiperEl.querySelector('.swiper-button-prev')
			}
		};

		new w.Swiper(servicesSwiperEl, servicesConfig);
	}

	// Mobile intro text clamp for Home Services section
	function initServicesIntroToggle() {
		function ensureWrappers() {
			var sectionHeads = d.querySelectorAll('.atl-services-section .section-head');
			sectionHeads.forEach(function(head, index) {
				if (head.querySelector('.js-atl-services-intro')) return;

				var introParagraph = head.querySelector(':scope > p');
				if (!introParagraph) return;

				var introId = introParagraph.id || ('atl-services-intro-auto-' + index);
				introParagraph.id = introId;
				introParagraph.classList.add('atl-services-intro__content', 'js-atl-services-intro-content');

				var wrapper = d.createElement('div');
				wrapper.className = 'atl-services-intro js-atl-services-intro';
				wrapper.setAttribute('data-mobile-lines', '3');

				var toggleBtn = d.createElement('button');
				toggleBtn.type = 'button';
				toggleBtn.className = 'atl-services-intro__toggle js-atl-services-intro-toggle';
				toggleBtn.setAttribute('aria-controls', introId);
				toggleBtn.setAttribute('aria-expanded', 'false');
				toggleBtn.hidden = true;
				toggleBtn.innerHTML = '<span class="screen-reader-text">Expand service introduction</span><span class="atl-services-intro__toggle-icon" aria-hidden="true"></span>';

				head.insertBefore(wrapper, introParagraph);
				wrapper.appendChild(introParagraph);
				wrapper.appendChild(toggleBtn);
			});
		}

		function applyState(wrapper) {
			var content = wrapper.querySelector('.js-atl-services-intro-content');
			var toggleBtn = wrapper.querySelector('.js-atl-services-intro-toggle');
			if (!content || !toggleBtn) return;

			var mobileLines = parseInt(wrapper.getAttribute('data-mobile-lines'), 10) || 3;
			wrapper.style.setProperty('--atl-mobile-lines', String(mobileLines));

			if (w.innerWidth > 767) {
				wrapper.classList.remove('has-toggle', 'is-collapsed', 'is-expanded');
				toggleBtn.hidden = true;
				toggleBtn.style.display = 'none';
				toggleBtn.setAttribute('aria-expanded', 'false');
				content.style.display = 'block';
				content.style.webkitLineClamp = 'unset';
				content.style.webkitBoxOrient = 'unset';
				content.style.overflow = 'visible';
				return;
			}

			wrapper.classList.remove('is-expanded');
			wrapper.classList.add('is-collapsed');
			toggleBtn.setAttribute('aria-expanded', 'false');

			content.style.display = '-webkit-box';
			content.style.webkitBoxOrient = 'vertical';
			content.style.webkitLineClamp = String(mobileLines);
			content.style.overflow = 'hidden';

			var hasOverflow = (content.scrollHeight - content.clientHeight) > 2;
			if (hasOverflow) {
				wrapper.classList.add('has-toggle');
				toggleBtn.hidden = false;
				toggleBtn.style.display = 'inline-flex';
			} else {
				wrapper.classList.remove('has-toggle', 'is-collapsed');
				toggleBtn.hidden = true;
				toggleBtn.style.display = 'none';
				content.style.display = 'block';
				content.style.webkitLineClamp = 'unset';
				content.style.webkitBoxOrient = 'unset';
				content.style.overflow = 'visible';
			}
		}

		function initIntroToggle() {
			ensureWrappers();
			var wrappers = d.querySelectorAll('.js-atl-services-intro');
			if (!wrappers.length) return;

			wrappers.forEach(function(wrapper) {
				var toggleBtn = wrapper.querySelector('.js-atl-services-intro-toggle');
				if (!toggleBtn || toggleBtn.getAttribute('data-toggle-bound') === '1') return;

				toggleBtn.setAttribute('data-toggle-bound', '1');
				toggleBtn.addEventListener('click', function() {
					var isCollapsed = wrapper.classList.contains('is-collapsed');
					var content = wrapper.querySelector('.js-atl-services-intro-content');
					var mobileLines = parseInt(wrapper.getAttribute('data-mobile-lines'), 10) || 3;

					if (isCollapsed) {
						wrapper.classList.remove('is-collapsed');
						wrapper.classList.add('is-expanded');
						toggleBtn.setAttribute('aria-expanded', 'true');
						if (content) {
							content.style.display = 'block';
							content.style.webkitLineClamp = 'unset';
							content.style.webkitBoxOrient = 'unset';
							content.style.overflow = 'visible';
						}
					} else {
						wrapper.classList.remove('is-expanded');
						wrapper.classList.add('is-collapsed');
						toggleBtn.setAttribute('aria-expanded', 'false');
						if (content) {
							content.style.display = '-webkit-box';
							content.style.webkitBoxOrient = 'vertical';
							content.style.webkitLineClamp = String(mobileLines);
							content.style.overflow = 'hidden';
						}
					}
				});
			});

			wrappers.forEach(applyState);
		}

		initIntroToggle();

		if (!initServicesIntroToggle._boundResize) {
			w.addEventListener('resize', function() {
				clearTimeout(w.__atlServicesIntroResizeTimer);
				w.__atlServicesIntroResizeTimer = setTimeout(initIntroToggle, 120);
			});
			initServicesIntroToggle._boundResize = true;
		}
	}

	// Mobile intro text clamp for Home Our Info section
	function initOurInfoIntroToggle() {
		function applyState(wrapper) {
			var content = wrapper.querySelector('.js-atl-our-info-intro-content');
			var toggleBtn = wrapper.querySelector('.js-atl-our-info-intro-toggle');
			if (!content || !toggleBtn) return;

			var mobileLines = parseInt(wrapper.getAttribute('data-mobile-lines'), 10) || 4;

			if (w.innerWidth > 767) {
				wrapper.classList.remove('has-toggle', 'is-collapsed', 'is-expanded');
				toggleBtn.hidden = true;
				toggleBtn.style.display = 'none';
				toggleBtn.setAttribute('aria-expanded', 'false');
				content.style.display = 'block';
				content.style.webkitLineClamp = 'unset';
				content.style.webkitBoxOrient = 'unset';
				content.style.overflow = 'visible';
				return;
			}

			wrapper.classList.remove('is-expanded');
			wrapper.classList.add('is-collapsed');
			toggleBtn.setAttribute('aria-expanded', 'false');

			content.style.display = '-webkit-box';
			content.style.webkitBoxOrient = 'vertical';
			content.style.webkitLineClamp = String(mobileLines);
			content.style.overflow = 'hidden';

			var hasOverflow = (content.scrollHeight - content.clientHeight) > 2;
			if (hasOverflow) {
				wrapper.classList.add('has-toggle');
				toggleBtn.hidden = false;
				toggleBtn.style.display = 'inline-flex';
			} else {
				wrapper.classList.remove('has-toggle', 'is-collapsed');
				toggleBtn.hidden = true;
				toggleBtn.style.display = 'none';
				content.style.display = 'block';
				content.style.webkitLineClamp = 'unset';
				content.style.webkitBoxOrient = 'unset';
				content.style.overflow = 'visible';
			}
		}

		function refreshAll() {
			d.querySelectorAll('.js-atl-our-info-intro').forEach(function(wrapper) {
				applyState(wrapper);
			});
		}

		var wrappers = d.querySelectorAll('.js-atl-our-info-intro');
		if (!wrappers.length) return;

		wrappers.forEach(function(wrapper) {
			var toggleBtn = wrapper.querySelector('.js-atl-our-info-intro-toggle');
			if (!toggleBtn || toggleBtn.getAttribute('data-toggle-bound') === '1') return;

			toggleBtn.setAttribute('data-toggle-bound', '1');
			toggleBtn.addEventListener('click', function() {
				var isCollapsed = wrapper.classList.contains('is-collapsed');
				var content = wrapper.querySelector('.js-atl-our-info-intro-content');
				var mobileLines = parseInt(wrapper.getAttribute('data-mobile-lines'), 10) || 4;

				if (isCollapsed) {
					wrapper.classList.remove('is-collapsed');
					wrapper.classList.add('is-expanded');
					toggleBtn.setAttribute('aria-expanded', 'true');
					if (content) {
						content.style.display = 'block';
						content.style.webkitLineClamp = 'unset';
						content.style.webkitBoxOrient = 'unset';
						content.style.overflow = 'visible';
					}
				} else {
					wrapper.classList.remove('is-expanded');
					wrapper.classList.add('is-collapsed');
					toggleBtn.setAttribute('aria-expanded', 'false');
					if (content) {
						content.style.display = '-webkit-box';
						content.style.webkitBoxOrient = 'vertical';
						content.style.webkitLineClamp = String(mobileLines);
						content.style.overflow = 'hidden';
					}
				}
			});
		});

		refreshAll();

		if (!initOurInfoIntroToggle._boundResize) {
			w.addEventListener('resize', function() {
				clearTimeout(w.__atlOurInfoIntroResizeTimer);
				w.__atlOurInfoIntroResizeTimer = setTimeout(refreshAll, 120);
			});
			initOurInfoIntroToggle._boundResize = true;
		}
	}

	// Initialize About Us Slider (Home - About Us shortcode)
	function initAboutSlider() {
		if (!w.Swiper) return;
		var aboutSwiperEl = d.querySelector('.atl-about-swiper');
		if (!aboutSwiperEl) return;

		var aboutSlides = aboutSwiperEl.querySelectorAll('.swiper-slide');
		if (!aboutSlides || aboutSlides.length === 0) return;

		var companyExp = aboutSwiperEl.closest('.company-exp');
		var taglineEl = companyExp ? companyExp.querySelector('.atl-about-tagline-inner') : null;

		function setTaglineWithTransition(newText) {
			if (!taglineEl) return;
			taglineEl.removeEventListener('transitionend', onTaglineOutEnd);
			taglineEl.removeEventListener('transitionend', onTaglineInEnd);
			taglineEl.classList.remove('atl-tagline-out', 'atl-tagline-in');

			function onTaglineOutEnd() {
				taglineEl.removeEventListener('transitionend', onTaglineOutEnd);
				taglineEl.textContent = newText || '';
				taglineEl.classList.remove('atl-tagline-out');
				taglineEl.classList.add('atl-tagline-in');
				w.requestAnimationFrame(function() {
					w.requestAnimationFrame(function() {
						taglineEl.addEventListener('transitionend', onTaglineInEnd);
						taglineEl.classList.remove('atl-tagline-in');
					});
				});
			}
			function onTaglineInEnd() {
				taglineEl.removeEventListener('transitionend', onTaglineInEnd);
			}

			taglineEl.addEventListener('transitionend', onTaglineOutEnd);
			taglineEl.classList.add('atl-tagline-out');
		}

		var swiperInstance = new w.Swiper(aboutSwiperEl, {
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 0,
			autoHeight: false,
			loop: aboutSlides.length > 1,
			grabCursor: true,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			pagination: {
				el: aboutSwiperEl.querySelector('.swiper-pagination'),
				clickable: true
			},
			navigation: {
				nextEl: aboutSwiperEl.querySelector('.atl-about-arrow-next'),
				prevEl: null
			},
			on: {
				slideChangeTransitionEnd: function() {
					var activeSlide = this.slides[this.activeIndex];
					var tagline = activeSlide ? activeSlide.getAttribute('data-tagline') : '';
					setTaglineWithTransition(tagline || '');
				}
			}
		});

		// Cập nhật tagline lần đầu theo slide đang hiển thị (quan trọng khi loop)
		if (taglineEl && swiperInstance.slides && swiperInstance.slides[swiperInstance.activeIndex]) {
			var firstActive = swiperInstance.slides[swiperInstance.activeIndex];
			var initialTagline = firstActive.getAttribute('data-tagline');
			if (initialTagline !== null) taglineEl.textContent = initialTagline;
		}
	}

	// Initialize Blogs Slider (Home - Blogs shortcode)
	function initBlogsSlider() {
		var blogsSwiperEl = d.querySelector('.atl-blogs-swiper');
		if (!blogsSwiperEl || !w.Swiper) return;

		var blogsConfig = {
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 20,
			autoHeight: false,
			loop: true,
			grabCursor: true,
			autoplay: false,
			breakpoints: {
				0: {
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 20
				},
				575: {
					slidesPerView: 2,
					slidesPerGroup: 1,
					spaceBetween: 30
				},
				991: {
					slidesPerView: 3,
					slidesPerGroup: 1,
					spaceBetween: 30
				},
				1366: {
					slidesPerView: 3,
					slidesPerGroup: 1,
					spaceBetween: 25
				}
			},
			navigation: {
				nextEl: blogsSwiperEl.querySelector('.swiper-button-next'),
				prevEl: blogsSwiperEl.querySelector('.swiper-button-prev')
			}
		};

		new w.Swiper(blogsSwiperEl, blogsConfig);
	}

	function updateProfileTestimonialsSwiperHeight(container) {
		if (!container || !container._atlTestimonialsSwiper) return;
		container._atlTestimonialsSwiper.updateAutoHeight(300);
	}

	function initProfileTestimonialQuoteToggle() {
		var MAX_LINES = 4;

		function applyState(wrapper) {
			var content = wrapper.querySelector('.js-atl-testimonial-quote-content');
			var toggleBtn = wrapper.querySelector('.js-atl-testimonial-quote-toggle');
			if (!content || !toggleBtn) return;

			var maxLines = parseInt(wrapper.getAttribute('data-max-lines'), 10) || MAX_LINES;
			var isExpanded = wrapper.classList.contains('is-expanded');

			if (isExpanded) {
				content.style.display = 'block';
				content.style.webkitLineClamp = 'unset';
				content.style.webkitBoxOrient = 'unset';
				content.style.overflow = 'visible';
				wrapper.classList.add('has-toggle');
				toggleBtn.hidden = false;
				toggleBtn.setAttribute('aria-expanded', 'true');
				return;
			}

			wrapper.classList.remove('is-expanded');
			wrapper.classList.add('is-collapsed');
			toggleBtn.setAttribute('aria-expanded', 'false');

			content.style.display = '-webkit-box';
			content.style.webkitBoxOrient = 'vertical';
			content.style.webkitLineClamp = String(maxLines);
			content.style.overflow = 'hidden';

			var hasOverflow = (content.scrollHeight - content.clientHeight) > 2;
			if (hasOverflow) {
				wrapper.classList.add('has-toggle');
				toggleBtn.hidden = false;
			} else {
				wrapper.classList.remove('has-toggle', 'is-collapsed');
				toggleBtn.hidden = true;
				content.style.display = 'block';
				content.style.webkitLineClamp = 'unset';
				content.style.webkitBoxOrient = 'unset';
				content.style.overflow = 'visible';
			}
		}

		function refreshAll() {
			d.querySelectorAll('.js-atl-testimonial-quote').forEach(function(wrapper) {
				applyState(wrapper);
			});
			var swiperContainer = d.querySelector('.atl-profile-testimonials-swiper');
			updateProfileTestimonialsSwiperHeight(swiperContainer);
		}

		var wrappers = d.querySelectorAll('.js-atl-testimonial-quote');
		if (!wrappers.length) return;

		wrappers.forEach(function(wrapper) {
			var toggleBtn = wrapper.querySelector('.js-atl-testimonial-quote-toggle');
			if (!toggleBtn || toggleBtn.getAttribute('data-toggle-bound') === '1') return;

			toggleBtn.setAttribute('data-toggle-bound', '1');
			toggleBtn.addEventListener('click', function() {
				var isCollapsed = wrapper.classList.contains('is-collapsed');
				var content = wrapper.querySelector('.js-atl-testimonial-quote-content');
				var maxLines = parseInt(wrapper.getAttribute('data-max-lines'), 10) || MAX_LINES;
				var swiperContainer = wrapper.closest('.atl-profile-testimonials-swiper');

				if (isCollapsed) {
					wrapper.classList.remove('is-collapsed');
					wrapper.classList.add('is-expanded', 'has-toggle');
					toggleBtn.setAttribute('aria-expanded', 'true');
					if (content) {
						content.style.display = 'block';
						content.style.webkitLineClamp = 'unset';
						content.style.webkitBoxOrient = 'unset';
						content.style.overflow = 'visible';
					}
				} else {
					wrapper.classList.remove('is-expanded');
					wrapper.classList.add('is-collapsed');
					toggleBtn.setAttribute('aria-expanded', 'false');
					if (content) {
						content.style.display = '-webkit-box';
						content.style.webkitBoxOrient = 'vertical';
						content.style.webkitLineClamp = String(maxLines);
						content.style.overflow = 'hidden';
					}
				}

				updateProfileTestimonialsSwiperHeight(swiperContainer);
			});
		});

		refreshAll();

		if (!initProfileTestimonialQuoteToggle._boundResize) {
			w.addEventListener('resize', function() {
				clearTimeout(w.__atlTestimonialQuoteResizeTimer);
				w.__atlTestimonialQuoteResizeTimer = setTimeout(refreshAll, 120);
			});
			initProfileTestimonialQuoteToggle._boundResize = true;
		}
	}

	function initProfileTestimonialsSlider() {
		if (!w.Swiper) return;
		var container = d.querySelector('.atl-profile-testimonials-swiper');
		if (!container) return;

		var wrap = container.closest('.atl-profile-testimonials-slider') || container;

		var slides = container.querySelectorAll('.swiper-slide');
		if (!slides || slides.length === 0) return;

		if (container._atlTestimonialsSwiper) {
			container._atlTestimonialsSwiper.destroy(true, true);
			container._atlTestimonialsSwiper = null;
		}

		container._atlTestimonialsSwiper = new w.Swiper(container, {
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: 24,
			autoHeight: true,
			loop: slides.length > 2,
			grabCursor: true,
			autoplay: false,
			navigation: {
				nextEl: wrap.querySelector('.swiper-button-next'),
				prevEl: wrap.querySelector('.swiper-button-prev')
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					slidesPerGroup: 2
				}
			}
		});

		initProfileTestimonialQuoteToggle();
	}

	// Enable a Swiper only on mobile; on desktop the markup falls back to the
	// original grid (Swiper is destroyed so CSS controls the layout).
	function initProfileMobileSlider(opts) {
		if (!w.Swiper) return;
		var container = d.querySelector(opts.containerSelector);
		if (!container) return;

		var wrap = container.closest(opts.wrapSelector) || container;

		var slides = container.querySelectorAll('.swiper-slide');
		if (!slides || slides.length === 0) return;

		var mq = w.matchMedia('(max-width: 767.98px)');

		function build() {
			if (container._atlMobileSwiper) return;
			container._atlMobileSwiper = new w.Swiper(container, {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 16,
				autoHeight: false,
				loop: false,
				grabCursor: true,
				autoplay: false,
				navigation: {
					nextEl: wrap.querySelector('.swiper-button-next'),
					prevEl: wrap.querySelector('.swiper-button-prev')
				},
				breakpoints: opts.breakpoints || {}
			});
		}

		function teardown() {
			if (container._atlMobileSwiper) {
				container._atlMobileSwiper.destroy(true, true);
				container._atlMobileSwiper = null;
			}
		}

		function apply(mql) {
			if (mql.matches) {
				build();
			} else {
				teardown();
			}
		}

		apply(mq);
		if (mq.addEventListener) {
			mq.addEventListener('change', apply);
		} else if (mq.addListener) {
			mq.addListener(apply);
		}
	}

	function initProfileServicesSlider() {
		initProfileMobileSlider({
			containerSelector: '.atl-profile-services-swiper',
			wrapSelector: '.atl-profile-services-slider'
		});
	}

	function initProfileProcessSlider() {
		initProfileMobileSlider({
			containerSelector: '.atl-profile-process-swiper',
			wrapSelector: '.atl-profile-process-slider',
			breakpoints: {
				576: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 20
				}
			}
		});
	}

	function initTourDurationFilter() {
		var form = d.getElementById('atl-duration-filter-form');
		var container = d.getElementById('atl-tours-grid-container');
		var inner = d.getElementById('atl-tours-grid-inner');
		if (!form || !inner || !container) return;

		var durationCheckboxes = form.querySelectorAll('.atl-duration-filter-checkbox');
		var travelStyleCheckboxes = form.querySelectorAll('.atl-travel-style-filter-checkbox');
		var locationCheckboxes = form.querySelectorAll('.atl-location-filter-checkbox');
		var ajaxUrl = typeof atlConfigAjax !== 'undefined' ? atlConfigAjax.ajax_url : '';

		function getDurationValues() {
			var values = [];
			durationCheckboxes.forEach(function(cb) {
				if (cb.checked) values.push(cb.value);
			});
			return values;
		}
		function getTravelStyleValues() {
			var values = [];
			travelStyleCheckboxes.forEach(function(cb) {
				if (cb.checked) values.push(cb.value);
			});
			return values;
		}
		function getLocationValues() {
			var values = [];
			locationCheckboxes.forEach(function(cb) {
				if (cb.checked) values.push(cb.value);
			});
			return values;
		}

		function setToursGridOverlay(show) {
			if (!container) return;
			if (w.getComputedStyle(container).position === 'static') {
				container.style.position = 'relative';
			}
			var overlay = container.querySelector('.atl-form-loading-overlay');
			if (!overlay) {
				overlay = d.createElement('div');
				overlay.className = 'atl-form-loading-overlay';
				overlay.innerHTML = '<div class="atl-loading-pic"><div class="loader"></div></div>';
				container.appendChild(overlay);
			}
			overlay.style.display = show ? 'flex' : 'none';
		}

		function doFilter(page) {
			var paged = page != null ? parseInt(page, 10) : 1;
			if (isNaN(paged) || paged < 1) paged = 1;
			var duration = getDurationValues();
			var travelStyle = getTravelStyleValues();
			var location = getLocationValues();
			var baseUrl = container.getAttribute('data-atl-tours-base-url') || w.location.href.split('?')[0];
			var context = container.getAttribute('data-atl-tours-context') || 'page';
			var taxonomy = container.getAttribute('data-atl-tours-taxonomy') || '';
			var termId = container.getAttribute('data-atl-tours-term-id') || '';

			setToursGridOverlay(true);
			var formData = new FormData();
			formData.append('action', 'atl_filter_tours');
			formData.append('paged', String(paged));
			formData.append('base_url', baseUrl);
			duration.forEach(function(v) { formData.append('duration[]', v); });
			travelStyle.forEach(function(v) { formData.append('travel_style[]', v); });
			location.forEach(function(v) { formData.append('location[]', v); });
			if (context === 'archive' && taxonomy && termId) {
				formData.append('taxonomy', taxonomy);
				formData.append('term_id', termId);
			}

			var xhr = new XMLHttpRequest();
			xhr.open('POST', ajaxUrl);
			xhr.onreadystatechange = function() {
				if (xhr.readyState !== 4) return;
				setToursGridOverlay(false);
				try {
					var res = JSON.parse(xhr.responseText);
					if (res.success && res.data && res.data.html !== undefined) {
						inner.innerHTML = res.data.html;
						if (res.data.result_count_text) {
							var resultCountEl = d.querySelector('.atl_result_count');
							if (resultCountEl) resultCountEl.textContent = res.data.result_count_text;
						}
					}
				} catch (e) {}
			};
			xhr.send(formData);
		}

		function getCheckboxLabel(cb, typePrefix) {
			var labelEl = cb.closest('label');
			var span = labelEl ? labelEl.querySelector('.atl-duration-filter-label, .atl-travel-style-filter-label, .atl-location-filter-label') : null;
			var text = span ? span.textContent.trim() : '';
			return typePrefix + text;
		}

		function updateAppliedFiltersBox() {
			var box = d.getElementById('atl-show-filters-applied');
			if (!box) return;
			var listEl = box.querySelector('.atl-filters-applied-list');
			if (!listEl) return;

			var items = [];
			form.querySelectorAll('.atl-duration-filter-checkbox:checked').forEach(function(cb) {
				items.push({ type: 'duration', value: cb.value, label: getCheckboxLabel(cb, 'Duration is ') });
			});
			form.querySelectorAll('.atl-travel-style-filter-checkbox:checked').forEach(function(cb) {
				items.push({ type: 'travel_style', value: cb.value, label: getCheckboxLabel(cb, 'Travel style is ') });
			});
			form.querySelectorAll('.atl-location-filter-checkbox:checked').forEach(function(cb) {
				items.push({ type: 'location', value: cb.value, label: getCheckboxLabel(cb, 'Location is ') });
			});

			var count = items.length;
			box.classList.toggle('atl-show-filters-applied--empty', count === 0);
			listEl.innerHTML = '';
			items.forEach(function(item) {
				var li = d.createElement('li');
				li.className = 'atl-filters-applied-item';
				var btn = d.createElement('button');
				btn.type = 'button';
				btn.className = 'atl-filter-remove';
				btn.setAttribute('data-filter-type', item.type);
				btn.setAttribute('data-filter-value', item.value);
				btn.setAttribute('aria-label', 'Remove filter');
				btn.innerHTML = '<i class="bi bi-x" aria-hidden="true"></i>';
				var span = d.createElement('span');
				span.className = 'atl-filters-applied-item-label';
				span.textContent = item.label;
				li.appendChild(btn);
				li.appendChild(span);
				listEl.appendChild(li);
			});
		}

		function removeFilter(type, value) {
			var name = type === 'duration' ? 'duration[]' : type === 'travel_style' ? 'travel_style[]' : 'location[]';
			var cb = form.querySelector('input[name="' + name + '"][value="' + value + '"]');
			if (cb) {
				cb.checked = false;
				updateAppliedFiltersBox();
				doFilter(1);
			}
		}

		function clearAllFilters() {
			form.querySelectorAll('.atl-duration-filter-checkbox, .atl-travel-style-filter-checkbox, .atl-location-filter-checkbox').forEach(function(cb) {
				cb.checked = false;
			});
			updateAppliedFiltersBox();
			doFilter(1);
		}

		// Show Filters Applied: remove one / clear all (delegate)
		var appliedBox = d.getElementById('atl-show-filters-applied');
		if (appliedBox) {
			appliedBox.addEventListener('click', function(e) {
				var removeBtn = e.target && e.target.closest ? e.target.closest('.atl-filter-remove') : null;
				if (removeBtn) {
					e.preventDefault();
					removeFilter(removeBtn.getAttribute('data-filter-type'), removeBtn.getAttribute('data-filter-value'));
					return;
				}
				if (e.target && e.target.id === 'atl-filters-clear-btn') {
					e.preventDefault();
					clearAllFilters();
				}
			});
		}

		durationCheckboxes.forEach(function(cb) {
			cb.addEventListener('change', function() {
				updateAppliedFiltersBox();
				doFilter(1);
			});
		});
		travelStyleCheckboxes.forEach(function(cb) {
			cb.addEventListener('change', function() {
				updateAppliedFiltersBox();
				doFilter(1);
			});
		});
		locationCheckboxes.forEach(function(cb) {
			cb.addEventListener('change', function() {
				updateAppliedFiltersBox();
				doFilter(1);
			});
		});

		updateAppliedFiltersBox();

		// Pagination: intercept clicks and load page via AJAX (keeps filter state)
		container.addEventListener('click', function(e) {
			var a = e.target && e.target.closest ? e.target.closest('a') : null;
			if (!a || !a.closest || !a.closest('.atl-pagination-ajax')) return;
			var page = a.getAttribute('data-page');
			if (page == null || page === '') return;
			page = parseInt(page, 10);
			if (isNaN(page) || page < 1) return;
			e.preventDefault();
			doFilter(page);
		});

		// Travel Style "Show more" toggle
		var showMoreBtn = form.querySelector('.atl-travel-style-show-more');
		if (showMoreBtn) {
			var hiddenItems = form.querySelectorAll('.atl-travel-style-item-hidden');
			var showMoreText = showMoreBtn.querySelector('.atl-travel-style-show-more-text');
			var chevron = showMoreBtn.querySelector('.atl-travel-style-chevron');
			var textMore = showMoreBtn.getAttribute('data-text-more') || 'Show more';
			var textLess = showMoreBtn.getAttribute('data-text-less') || 'Show less';
			showMoreBtn.addEventListener('click', function() {
				var state = showMoreBtn.getAttribute('data-state') || 'more';
				if (state === 'more') {
					hiddenItems.forEach(function(el) { el.classList.remove('atl-travel-style-item-hidden'); });
					showMoreBtn.setAttribute('data-state', 'less');
					showMoreBtn.setAttribute('aria-expanded', 'true');
					if (showMoreText) showMoreText.textContent = textLess;
					if (chevron) { chevron.classList.remove('bi-chevron-down'); chevron.classList.add('bi-chevron-up'); }
				} else {
					hiddenItems.forEach(function(el) { el.classList.add('atl-travel-style-item-hidden'); });
					showMoreBtn.setAttribute('data-state', 'more');
					showMoreBtn.setAttribute('aria-expanded', 'false');
					if (showMoreText) showMoreText.textContent = textMore;
					if (chevron) { chevron.classList.add('bi-chevron-down'); chevron.classList.remove('bi-chevron-up'); }
				}
			});
		}

		// Location "Show more" toggle (show 15 when expanded)
		var locationShowMoreBtn = form.querySelector('.atl-location-show-more');
		if (locationShowMoreBtn) {
			var locationHiddenItems = form.querySelectorAll('.atl-location-item-hidden');
			var locationShowMoreText = locationShowMoreBtn.querySelector('.atl-location-show-more-text');
			var locationChevron = locationShowMoreBtn.querySelector('.atl-location-chevron');
			var locTextMore = locationShowMoreBtn.getAttribute('data-text-more') || 'Show more';
			var locTextLess = locationShowMoreBtn.getAttribute('data-text-less') || 'Show less';
			locationShowMoreBtn.addEventListener('click', function() {
				var state = locationShowMoreBtn.getAttribute('data-state') || 'more';
				if (state === 'more') {
					locationHiddenItems.forEach(function(el) { el.classList.remove('atl-location-item-hidden'); });
					locationShowMoreBtn.setAttribute('data-state', 'less');
					locationShowMoreBtn.setAttribute('aria-expanded', 'true');
					if (locationShowMoreText) locationShowMoreText.textContent = locTextLess;
					if (locationChevron) { locationChevron.classList.remove('bi-chevron-down'); locationChevron.classList.add('bi-chevron-up'); }
				} else {
					locationHiddenItems.forEach(function(el) { el.classList.add('atl-location-item-hidden'); });
					locationShowMoreBtn.setAttribute('data-state', 'more');
					locationShowMoreBtn.setAttribute('aria-expanded', 'false');
					if (locationShowMoreText) locationShowMoreText.textContent = locTextMore;
					if (locationChevron) { locationChevron.classList.add('bi-chevron-down'); locationChevron.classList.remove('bi-chevron-up'); }
				}
			});
		}
	}

	// FAQs Toggle All Functionality
	function initFaqsToggleAll() {
		var toggleButtons = d.querySelectorAll('[id$="-toggle-all"]');
		
		toggleButtons.forEach(function(toggleBtn) {
			var toggleIcon = toggleBtn.querySelector('.toggle-icon');
			if (!toggleIcon) return;
			
			// Extract uniqueId from button ID (e.g., "atl-faqs-12345-toggle-all" -> "atl-faqs-12345")
			var buttonId = toggleBtn.id;
			var uniqueId = buttonId.replace('-toggle-all', '');
			
			// Get default state from data attribute
			var defaultState = toggleBtn.getAttribute('data-default-state') || 'expanded';
			var isDefaultExpanded = defaultState === 'expanded';
			
			toggleBtn.addEventListener('click', function() {
				var leftAccordion = d.getElementById(uniqueId + '-accordion-left');
				var rightAccordion = d.getElementById(uniqueId + '-accordion-right');
				var allCollapses = [];
				
				if (leftAccordion) {
					var leftCollapses = leftAccordion.querySelectorAll('.collapse');
					for (var i = 0; i < leftCollapses.length; i++) {
						allCollapses.push(leftCollapses[i]);
					}
				}
				if (rightAccordion) {
					var rightCollapses = rightAccordion.querySelectorAll('.collapse');
					for (var j = 0; j < rightCollapses.length; j++) {
						allCollapses.push(rightCollapses[j]);
					}
				}

				if (allCollapses.length === 0) return;

				// Kiểm tra trạng thái hiện tại
				var firstCollapse = allCollapses[0];
				var isCurrentlyExpanded = firstCollapse.classList.contains('show');

				// Toggle tất cả
				allCollapses.forEach(function(collapse) {
					var panel = collapse.closest('.panel');
					var link = panel ? panel.querySelector('.acod-head .acod-title a') : null;
					
					if (isCurrentlyExpanded) {
						// Đóng tất cả
						collapse.classList.remove('show');
						if (link) {
							link.classList.add('collapsed');
							link.setAttribute('aria-expanded', 'false');
						}
					} else {
						// Mở tất cả
						collapse.classList.add('show');
						if (link) {
							link.classList.remove('collapsed');
							link.setAttribute('aria-expanded', 'true');
						}
					}
				});

				// Cập nhật icon của button
				if (isCurrentlyExpanded) {
					toggleIcon.classList.remove('bi-chevron-up');
					toggleIcon.classList.add('bi-chevron-down');
				} else {
					toggleIcon.classList.remove('bi-chevron-down');
					toggleIcon.classList.add('bi-chevron-up');
				}
			});
		});
	}

	if (d.readyState === 'loading') {
		d.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})(window, document);

